"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Device_1 = require("../models/Device");
var StateProvider_1 = require("./StateProvider");
var CartActions_1 = require("../models/CartActions");
var WirelessConstants_1 = require("./WirelessConstants");
var events_1 = require("events");
var CartActions_2 = require("../models/CartActions");
var Analytics_1 = require("../models/Analytics");
/**
 * Utilities class is used to define all common functionalities
 * which can be used in any component.
 *
 * @export
 * @class Utilities
 */
var Utilities = /** @class */ (function () {
    function Utilities() {
    }
    // Check if passed object is MNM, Mixandmach.
    Utilities.isDisplayGroupMnM = function (obj) {
        return obj && !this.isEmptyObject(obj.product.displayGroups) &&
            obj.product.displayGroups[0].key === 'mixAndMatch';
    };
    // Check if passed object is MNM or not.
    Utilities.isMnM = function (obj) {
        return obj && obj.product.isMnM;
    };
    Utilities.getFirstLosgTypeFromCart = function () {
        var losg = Utilities.getFirstAddedLosgFromCart();
        if (!Utilities.isEmptyObject(losg) && Utilities.isKeyExist(losg, 'losgType')) {
            return losg.losgType;
        }
    };
    // Check if passed object is LLP or not.
    Utilities.isLLP = function (obj) {
        return obj && obj.product.isLLP;
    };
    // Check if passed object is undefined or empty or null.
    Utilities.isEmptyObject = function (obj) {
        return (obj === null
            || typeof obj === 'undefined'
            || typeof obj !== 'object'
            || (Object.keys(obj).length === 0));
    };
    // Check if passed object is undefined or empty or null.
    Utilities.isIgnoreLOSG = function (losgType) {
        return (losgType === null
            || typeof losgType === 'undefined'
            || typeof losgType !== 'string'
            || losgType === 'change'
            || losgType === 'CHANGE'
            || losgType === 'NO_CHANGE');
    };
    // Append '/' for each billing Note of Price Container.
    Utilities.appendToBillingNote = function (billingNote) {
        if (billingNote === ('month') || billingNote === ('monthly') ||
            !Utilities.isEmptyObject(billingNote) && billingNote.includes('month')) {
            billingNote = '/mo.';
        }
        else {
            billingNote = '/' + billingNote;
        }
        return billingNote;
    };
    // check if passed value is float or not
    // tslint:disable-next-line:no-any
    Utilities.isFloat = function (n) {
        return Number(n) === n && n % 1 !== 0;
    };
    // Check if passed key chain is exist in passed object.
    // tslint:disable-next-line:no-any
    Utilities.isKeyExist = function (obj, key) {
        var _this = this;
        if (this.isEmpty(key)) {
            return false;
        }
        return key.split('.').every(function (s) {
            if (_this.isEmptyObject(obj) || !obj.hasOwnProperty(s)) {
                return false;
            }
            obj = obj[s];
            return true;
        });
    };
    // check if key exists in array of objects
    // tslint:disable-next-line:no-any
    Utilities.isKeyExistsInArray = function (arr, key) {
        if (this.isEmpty(key)) {
            return false;
        }
        // tslint:disable-next-line:no-any
        return arr && arr.some(function (obj) { return obj.hasOwnProperty(key); });
    };
    // Check if passed value is undefined or empty or null.
    Utilities.isEmpty = function (value) {
        return (value === null || typeof value === 'undefined' || (value === ''));
    };
    // tslint:disable-next-line:no-any
    Utilities.getJsonPathValue = function (obj, jsonPath) {
        var _this = this;
        if (this.isEmpty(jsonPath)) {
            return null;
        }
        var value;
        var iskeyExists = jsonPath.split('.').every(function (s) {
            if (_this.isEmptyObject(obj) || !obj.hasOwnProperty(s)) {
                return false;
            }
            obj = obj[s];
            value = obj;
            return true;
        });
        if (iskeyExists) {
            return value;
        }
        return null;
    };
    // get selectedByodDeviceType when coming from PSC
    Utilities.getSelectedByodDeviceTypeFromPSC = function () {
        if (!Utilities.isEmpty(sessionStorage.getItem('selectedByodDeviceType'))) {
            return sessionStorage.getItem('selectedByodDeviceType');
        }
        else {
            return '';
        }
    };
    // To get the losg item from cart.
    Utilities.getLosgItemFromCart = function (losgId, itemType, subType, skipOfferIdCheck) {
        if (this.isEmpty(itemType)) {
            return null;
        }
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        var item = null;
        if (this.isKeyExist(cartResponse, 'content.payload.wirelessCart')) {
            var wirelessCart = cartResponse.content.payload.wirelessCart;
            if (this.isKeyExist(wirelessCart, 'losgs')) {
                if (this.isEmpty(losgId) && !this.isEmptyObject(wirelessCart.losgs) &&
                    (!wirelessCart._paymentType || (!Utilities.isEmpty(wirelessCart._paymentType) &&
                        wirelessCart._paymentType.toUpperCase() === Utilities.getWirelessType()))) {
                    item = this.getLineItemFromCart(wirelessCart.losgs, itemType, subType);
                }
                else {
                    var losg = wirelessCart.losgs[losgId];
                    if (!this.isEmptyObject(losg) && this.isKeyExist(losg, 'lineItems') &&
                        !Utilities.isEmptyObject(losg.lineItems)) {
                        Object.values(losg.lineItems).forEach(function (lineItem) {
                            if (!Utilities.isEmpty(lineItem._itemType)) {
                                var iType = lineItem._itemType.toUpperCase();
                                var productSubType = lineItem.productSubType ? lineItem.productSubType.toUpperCase() : '';
                                if (itemType && iType === itemType.toUpperCase() && (skipOfferIdCheck || lineItem.offerId ? lineItem.offerId !== 'NOT_AVAILABLE' : true)) {
                                    if (subType) {
                                        if (productSubType === subType.toUpperCase()) {
                                            item = lineItem;
                                        }
                                    }
                                    else {
                                        item = lineItem;
                                    }
                                }
                            }
                        });
                    }
                }
            }
        }
        return item;
    };
    // To get all SDG SDFs From Cart Response other than current losgId.
    Utilities.getIOOfferRequestSDGSDFsFromCart = function (losgId) {
        var _this = this;
        var entertainmentPromoReqObj = { wireless: { sharedDataFeatures: [] } };
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        var wirelessCart = Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart') &&
            cartResponse.content.payload.wirelessCart;
        if (wirelessCart && (!wirelessCart._paymentType && Utilities.getWirelessType() === "POSTPAID" /* POSTPAID */) &&
            this.isKeyExist(wirelessCart, 'losgs') && !Utilities.isEmptyObject(wirelessCart.losgs)) {
            var losgs_1 = wirelessCart.losgs;
            if (this.isKeyExist(wirelessCart, 'losgs')) {
                Object.keys(losgs_1).forEach(function (losgKey) {
                    if (losgKey !== losgId) {
                        var losg = losgs_1[losgKey];
                        if (_this.isKeyExist(losg, 'lineItems') && !_this.isEmptyObject(losg.lineItems)) {
                            var lineItems = losg.lineItems;
                            Object.values(lineItems).forEach(function (lineItem) {
                                if (!Utilities.isEmpty(lineItem._itemType)) {
                                    var iType = lineItem._itemType.toUpperCase();
                                    if (iType === CartActions_1.ItemType.SHARED_DATA_FEATURE.toString().toUpperCase()) {
                                        entertainmentPromoReqObj.wireless.sharedDataFeatures.push({ productId: lineItem.offerId, skuId: lineItem.productSKU });
                                    }
                                    else if (iType === CartActions_1.ItemType.SHARED_DATA_GROUP.toString().toUpperCase()) {
                                        entertainmentPromoReqObj.wireless.sharedDataGroup = {
                                            productId: lineItem.offerId,
                                            skuId: lineItem.productSKU,
                                        };
                                    }
                                }
                            });
                        }
                    }
                });
            }
        }
        return entertainmentPromoReqObj;
    };
    Utilities.getLosgItemFromHBOMaxCart = function (losgId, itemType) {
        if (this.isEmpty(itemType)) {
            return null;
        }
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        var item = null;
        if (this.isKeyExist(cartResponse, 'content.payload.hbomaxCart')) {
            var hbomaxCart = cartResponse.content.payload.hbomaxCart;
            if (this.isKeyExist(hbomaxCart, 'losgs')) {
                if (this.isEmpty(losgId) && !this.isEmptyObject(hbomaxCart.losgs)) {
                    item = this.getLineItemFromCart(hbomaxCart.losgs, itemType);
                }
                else {
                    var losg = hbomaxCart.losgs[losgId];
                    if (!this.isEmptyObject(losg) && this.isKeyExist(losg, 'lineItems') &&
                        !Utilities.isEmptyObject(losg.lineItems)) {
                        Object.values(losg.lineItems).forEach(function (lineItem) {
                            if (!Utilities.isEmpty(lineItem._itemType)) {
                                var iType = lineItem._itemType.toUpperCase();
                                if (itemType && iType === itemType.toUpperCase()) {
                                    item = lineItem;
                                }
                            }
                        });
                    }
                }
            }
        }
        return item;
    };
    Utilities.getConnectedCarLosgFromCart = function () {
        var _this = this;
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        var connectedCarLosg = null;
        if (this.isKeyExist(cartResponse, 'content.payload.wirelessCart')) {
            var wirelessCart = cartResponse.content.payload.wirelessCart;
            if (this.isKeyExist(wirelessCart, 'losgs')) {
                var losgs_2 = wirelessCart.losgs;
                Object.keys(losgs_2).forEach(function (losgKey) {
                    var losg = losgs_2[losgKey];
                    if (_this.isKeyExist(losg, 'losgType') && losg.losgType === CartActions_2.LosgType.NO_CHANGE) {
                        connectedCarLosg = losg;
                    }
                });
                return connectedCarLosg;
            }
        }
    };
    // To get the line items from cart.
    Utilities.getLineItemsFromCart = function (losgId, itemType) {
        if (this.isEmpty(itemType)) {
            return null;
        }
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        var items = [];
        if (this.isKeyExist(cartResponse, 'content.payload.wirelessCart')) {
            var wirelessCart = cartResponse.content.payload.wirelessCart;
            if (this.isKeyExist(wirelessCart, 'losgs')) {
                var losg = wirelessCart.losgs[losgId];
                if (!this.isEmptyObject(losg) && this.isKeyExist(losg, 'lineItems') &&
                    !Utilities.isEmptyObject(losg.lineItems)) {
                    Object.values(losg.lineItems).forEach(function (lineItem) {
                        if (!Utilities.isEmpty(lineItem._itemType)) {
                            var iType = lineItem._itemType.toUpperCase();
                            if (itemType && iType === itemType.toUpperCase()) {
                                items.push(lineItem);
                            }
                        }
                    });
                }
            }
        }
        return items;
    };
    // method to check whether flow is BYOD or not
    Utilities.isBYODFlow = function (sendLosg, cartResponse, isBYODOnly, nonBYODDevice) {
        var _this = this;
        var isBYOD = false;
        var isNonBYODLosg = false;
        var byodLosg = null;
        if (!isBYODOnly) {
            isBYODOnly = false;
        }
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        if (Utilities.isEmptyObject(cartResponse)) {
            cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        }
        var wirelessCart = Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart') &&
            cartResponse.content.payload.wirelessCart;
        if (wirelessCart && ((!wirelessCart._paymentType && Utilities.getWirelessType() === "POSTPAID" /* POSTPAID */)
            || (wirelessCart._paymentType && Utilities.getWirelessType() === "PREPAID" /* PREPAID */)) &&
            this.isKeyExist(wirelessCart, 'losgs') && !Utilities.isEmptyObject(wirelessCart.losgs)) {
            var losgs_3 = wirelessCart.losgs;
            Object.keys(losgs_3).forEach(function (losgKey) {
                var losg = losgs_3[losgKey];
                if (_this.getLosgItemFromCart(losg.id, CartActions_1.ItemType.HARDGOOD.toString())) {
                    if (_this.isKeyExist(losg, 'lineItems') && !_this.isEmptyObject(losg.lineItems)) {
                        var lineItems_1 = losg.lineItems;
                        Object.keys(lineItems_1).forEach(function (lineItemKey) {
                            if (!Utilities.isEmpty(lineItems_1[lineItemKey]._itemType) &&
                                _this.isKeyExist(lineItems_1[lineItemKey], 'hardGood.byodIndicator')) {
                                var iType = lineItems_1[lineItemKey]._itemType.toUpperCase();
                                if (iType === CartActions_1.ItemType.HARDGOOD.toUpperCase() &&
                                    lineItems_1[lineItemKey].hardGood.byodIndicator) {
                                    if (sendLosg) {
                                        byodLosg = losg;
                                    }
                                    isBYOD = true;
                                }
                            }
                        });
                    }
                }
                else {
                    isNonBYODLosg = true;
                }
            });
        }
        if (sendLosg) {
            return byodLosg;
        }
        if (nonBYODDevice) {
            return isNonBYODLosg;
        }
        return isBYODOnly ? !isNonBYODLosg && isBYOD : isBYOD;
    };
    Utilities.isBYODLosg = function (losg) {
        var _this = this;
        var isBYOD = false;
        if (!Utilities.isEmptyObject(losg) && this.isKeyExist(losg, 'lineItems') && !this.isEmptyObject(losg.lineItems)) {
            var lineItems_2 = losg.lineItems;
            Object.keys(lineItems_2).forEach(function (lineItemKey) {
                if (!Utilities.isEmpty(lineItems_2[lineItemKey]._itemType) &&
                    _this.isKeyExist(lineItems_2[lineItemKey], 'hardGood.byodIndicator')) {
                    var iType = lineItems_2[lineItemKey]._itemType.toUpperCase();
                    if (iType === CartActions_1.ItemType.HARDGOOD.toUpperCase() &&
                        lineItems_2[lineItemKey].hardGood.byodIndicator) {
                        isBYOD = true;
                        return isBYOD;
                    }
                }
            });
        }
        return isBYOD;
    };
    Utilities.updateIntendedDevices = function (productCode, productSKU) {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var intendedDevices = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_INTENDED_DEVICES);
        var filteredIntendedDevices;
        var selectedDeviceTypeFilter = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_SELECTED_DEVICE_TYPE_FILTER);
        if (intendedDevices instanceof Array && selectedDeviceTypeFilter) {
            filteredIntendedDevices = Utilities.cloneObject(intendedDevices);
            if (!Utilities.isEmptyObject(filteredIntendedDevices)) {
                filteredIntendedDevices.map(function (intendedDevice) {
                    if (intendedDevice && intendedDevice.id === selectedDeviceTypeFilter.id &&
                        !Utilities.isEmpty(intendedDevice.deviceType) && !Utilities.isEmpty(selectedDeviceTypeFilter.deviceType) &&
                        intendedDevice.deviceType.toUpperCase() === selectedDeviceTypeFilter.deviceType.toUpperCase()) {
                        intendedDevice.productCode = productCode;
                        intendedDevice.productSKU = productSKU;
                        intendedDevice.isAddedToCart = true;
                    }
                });
            }
            stateManager.set(WirelessConstants_1.WirelessConstants.WIRELESS_INTENDED_DEVICES, filteredIntendedDevices);
        }
    };
    Utilities.getActionType = function (losgId, continueFlow) {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        if (losgId) {
            if (Utilities.getWirelessType() === "PREPAID" /* PREPAID */ &&
                Utilities.isFeatureEnabled('prepaid-multiline')) {
                var deviceInCart = Utilities.getLosgItemFromCart(losgId, CartActions_1.ItemType.DEVICE.toString());
                return deviceInCart ? CartActions_1.ActionType.MODIFY : CartActions_1.ActionType.ADD;
            }
            else if (Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs')) {
                var losgs = cartResponse.content.payload.wirelessCart.losgs;
                if (losgs[losgId]) {
                    var lineWithDevice = Object.values(losgs[losgId].lineItems)
                        .find(function (line) { return line._itemType.toLowerCase() === 'device'; });
                    if (lineWithDevice && !continueFlow) {
                        return CartActions_1.ActionType.MODIFY;
                    }
                    else {
                        return CartActions_1.ActionType.ADD;
                    }
                }
            }
            else {
                return CartActions_1.ActionType.MODIFY;
            }
        }
        else {
            return CartActions_1.ActionType.ADD;
        }
    };
    // to check whether insurance is selected
    Utilities.isInsuranceInCart = function (featureItem) {
        var isInsuranceInCart = false;
        if (!this.isEmptyObject(featureItem)) {
            if (this.isKeyExist(featureItem, 'productSubType') &&
                featureItem.productSubType.toLowerCase() === 'insurance') {
                isInsuranceInCart = true;
            }
        }
        return isInsuranceInCart;
    };
    Utilities.deviceAndPlanInCart = function () {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        var plan;
        var planInCart;
        if (Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs')) {
            plan = Utilities.getLineItemFromCart(cartResponse.content.payload.wirelessCart.losgs, CartActions_1.ItemType.SHARED_DATA_GROUP.toString());
            if (!plan) {
                plan = Utilities.getLineItemFromCart(cartResponse.content.payload.wirelessCart.losgs, CartActions_1.ItemType.VOICEPLAN.toString());
            }
            if (!plan) {
                plan = Utilities.getLineItemFromCart(cartResponse.content.payload.wirelessCart.losgs, CartActions_1.ItemType.DATAPLAN.toString());
            }
        }
        planInCart = plan ? true : false;
        var deviceIncart = false;
        if (Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs')) {
            var planOnly = Object.values(cartResponse.content.payload.wirelessCart.losgs);
            for (var _i = 0, planOnly_1 = planOnly; _i < planOnly_1.length; _i++) {
                var losgs = planOnly_1[_i];
                // searches for device lineitem in cart
                var foundDevice = losgs.lineItems && Object.values(losgs.lineItems).find(function (lines) {
                    return lines.itemType === 'device';
                });
                if (foundDevice) {
                    deviceIncart = true;
                    break;
                }
            }
        }
        return deviceIncart && planInCart;
    };
    // To get the losg item from cart.
    Utilities.getLineItemFromCart = function (losgs, itemType, itemSubType) {
        var _this = this;
        if (this.isEmptyObject(losgs) || this.isEmpty(itemType)) {
            return null;
        }
        var item = null;
        if (!Utilities.isEmptyObject(losgs)) {
            Object.keys(losgs).forEach(function (losgKey) {
                var losg = losgs[losgKey];
                if (_this.isKeyExist(losg, 'lineItems') && !_this.isEmptyObject(losg.lineItems)) {
                    var lineItems_3 = losg.lineItems;
                    Object.keys(lineItems_3).forEach(function (lineItemKey) {
                        if (!Utilities.isEmpty(lineItems_3[lineItemKey]._itemType)) {
                            var iType = lineItems_3[lineItemKey]._itemType.toUpperCase();
                            var productSubType = lineItems_3[lineItemKey].productSubType;
                            if (itemType && iType === itemType.toUpperCase() && lineItems_3[lineItemKey] &&
                                lineItems_3[lineItemKey].offerId !== 'NOT_AVAILABLE') {
                                if (itemSubType && productSubType &&
                                    productSubType.toUpperCase() === itemSubType.toUpperCase()) {
                                    item = lineItems_3[lineItemKey];
                                }
                                else {
                                    item = lineItems_3[lineItemKey];
                                }
                            }
                        }
                    });
                }
            });
        }
        return item;
    };
    // To get the lineItem from cart
    Utilities.getLineFromCart = function (productCode, productSKU, itemType) {
        if (this.isEmpty(itemType)) {
            return null;
        }
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        var item = null;
        if (this.isKeyExist(cartResponse, 'content.payload.wirelessCart')) {
            var wirelessCart = cartResponse.content.payload.wirelessCart;
            if (this.isKeyExist(wirelessCart, 'losgs') && !Utilities.isEmptyObject(wirelessCart.losgs)) {
                Object.values(wirelessCart.losgs).forEach(function (losg) {
                    if (!Utilities.isEmptyObject(losg.lineItems)) {
                        Object.values(losg.lineItems).forEach(function (lineItem) {
                            if (lineItem && lineItem.offerId === productCode && lineItem.productSKU === productSKU) {
                                item = lineItem;
                            }
                        });
                    }
                });
            }
        }
        return item;
    };
    Utilities.removePortinonlyLosg = function (losgId, itemSku) {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var portinOnlyInfo = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_PORTIN_ONLY);
        if (!Utilities.isEmptyObject(portinOnlyInfo) && portinOnlyInfo.length > 0) {
            for (var _i = 0, portinOnlyInfo_1 = portinOnlyInfo; _i < portinOnlyInfo_1.length; _i++) {
                var portinOffer = portinOnlyInfo_1[_i];
                if (portinOffer.losgId === losgId && portinOffer.skuId === itemSku) {
                    portinOnlyInfo.splice(portinOnlyInfo.indexOf(portinOffer), 1);
                }
            }
            stateManager.set(WirelessConstants_1.WirelessConstants.WIRELESS_PORTIN_ONLY, portinOnlyInfo);
        }
    };
    // To get the losg item from cart.
    Utilities.getLosgForLineItem = function (losgs, lineId) {
        if (this.isEmptyObject(losgs) || this.isEmpty(lineId)) {
            return null;
        }
        var losg = null;
        var lineItem = null;
        if (!Utilities.isEmptyObject(losgs)) {
            Object.keys(losgs).forEach(function (losgKey) {
                /**
                 * We already found losg, return losg from here.
                 */
                if (!Utilities.isEmptyObject(lineItem)) {
                    return losg;
                }
                if (!Utilities.isIgnoreLOSG(losgs[losgKey].losgType)) {
                    lineItem = Object.values(losgs[losgKey].lineItems).find(function (lItem) { return lItem.id === lineId; });
                    losg = losgs[losgKey];
                }
            });
        }
        return losg;
    };
    // To clone the object.
    Utilities.cloneObject = function (obj) {
        if (this.isEmptyObject(obj)) {
            return null;
        }
        return JSON.parse(JSON.stringify(obj));
    };
    Utilities.getFeatureToggle = function () {
        var featureToggleConfig = require('../mocks/featureToggle.json');
        if (Utilities.getWirelessType() === "PREPAID" /* PREPAID */) {
            featureToggleConfig =
                Object.assign({}, featureToggleConfig, { 'remove-insurance-wizard': { value: true } });
        }
        return featureToggleConfig;
    };
    // To get the feature toggle value.
    Utilities.getFeatureToggleConfig = function (feature) {
        if (this.isEmpty(feature)) {
            return null;
        }
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var featureToggleConfig = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_FEATURE_TOGGLE_KEY);
        if (Utilities.isEmptyObject(featureToggleConfig)) {
            return null;
        }
        if (!Utilities.isKeyExist(featureToggleConfig, feature)) {
            return null;
        }
        return featureToggleConfig[feature];
    };
    Utilities.isFeatureEnabled = function (feature) {
        if (this.isEmpty(feature)) {
            return false;
        }
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var featureToggleList = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_FEATURE_TOGGLE_KEY);
        if (Utilities.isEmptyObject(featureToggleList)) {
            return false;
        }
        if (Utilities.isKeyExist(featureToggleList, feature + '.value')) {
            return featureToggleList[feature].value;
        }
        else {
            return false;
        }
    };
    Utilities.canDisplayRTI = function () {
        return Utilities.getWirelessType() === 'PREPAID' ?
            Utilities.isIxpFeatureEnabled('svc-pcv1-display-rti') && Utilities.isIxpFeatureEnabled('svc-pcv1-display-prepaid-rti')
            : Utilities.isIxpFeatureEnabled('svc-pcv1-display-rti');
    };
    Utilities.updateSaleStatusToComingSoon = function (saleStatus) {
        if (saleStatus && (saleStatus.toUpperCase() === WirelessConstants_1.SalesStatus.PREPREORDER)) {
            if (!Utilities.isIxpFeatureEnabled('svc-pcv1-pre-preorder') || !this.isPpoEnabled()) {
                return WirelessConstants_1.SalesStatus.COMINGSOON;
            }
            else {
                return saleStatus;
            }
        }
        return saleStatus;
    };
    Utilities.isPpoEnabled = function () {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var appshellPpoIntent = stateManager.get(WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE, WirelessConstants_1.WirelessConstants.APPSHELL_WIRELESS_PPO_INTENT);
        var ppoIntent = appshellPpoIntent === null || appshellPpoIntent === void 0 ? void 0 : appshellPpoIntent.ppo;
        if (ppoIntent && !Utilities.getCookie('DTAB')) {
            return ppoIntent === 'true' ? true : false;
        }
        return false;
    };
    Utilities.isIxpFeatureEnabled = function (feature) {
        if (feature === 'svc-idp-wireless-enable-mix-n-match-plans') {
            feature = Utilities.getCustomerType() === "CRU" /* CRU */ ?
                'svc-idp-wireless-enable-mix-n-match-plans-smb' :
                'svc-idp-wireless-enable-mix-n-match-plans';
        }
        if (feature === 'svc-idp-wireless-enable-mix-n-match-plans') {
            return true;
        }
        var prodIXP = Utilities.getProdEnabledIXPFlags();
        if (prodIXP.includes(feature)) {
            return true;
        }
        else {
            var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
            var featureToggleData = stateManager.get('appShell', 'featureToggleStatus');
            if (featureToggleData && featureToggleData.allocations
                && featureToggleData.allocations[feature]) {
                if (featureToggleData.allocations[feature].value === 'true') {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        }
    };
    /**
     * @function isEligibleForNextUpDefaultOffer
     * @description Checks if the user is eligible for
     * default nextup checkbox offer.
     * @returns {boolean}
     */
    Utilities.isEligibleForNextUpDefaultOffer = function () {
        var _a;
        var selectedCtn = '';
        var cartResponse = StateProvider_1.StateProvider.getStateManagerInstance().get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        var authDetails = Utilities.getAuthDetails();
        if (!Utilities.isEmptyObject(cartResponse) &&
            Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs') &&
            !Utilities.isEmptyObject(cartResponse.content.payload.wirelessCart.losgs)) {
            Object.values(cartResponse.content.payload.wirelessCart.losgs).forEach(function (value) {
                var _a, _b;
                if ((_a = value === null || value === void 0 ? void 0 : value._extraParams) === null || _a === void 0 ? void 0 : _a.associatedCtn) {
                    selectedCtn = (_b = value === null || value === void 0 ? void 0 : value._extraParams) === null || _b === void 0 ? void 0 : _b.associatedCtn;
                }
            });
        }
        var selectedUpgradeCtn = !Utilities.isEmpty(selectedCtn) &&
            ((_a = authDetails === null || authDetails === void 0 ? void 0 : authDetails.upgradeEligibilityInfo) === null || _a === void 0 ? void 0 : _a.subscribers.find(function (e) {
                return (e === null || e === void 0 ? void 0 : e.subscriberNumber) === selectedCtn;
            }));
        if (Utilities.isUpgradeFlow() &&
            Utilities.isIxpFeatureEnabled('svc-default-next-up-selection') &&
            !Utilities.isEmptyObject(authDetails) &&
            !Utilities.isEmptyObject(selectedUpgradeCtn) &&
            Utilities.getCustomerSelectedOption() !== "PAYOFF" /* PAYOFF */ &&
            (selectedUpgradeCtn === null || selectedUpgradeCtn === void 0 ? void 0 : selectedUpgradeCtn.isNextUp)) {
            return true;
        }
        return false;
    };
    Utilities.getZipFromCookie = function () {
        var name = 'attPersistantLocalization' + '=';
        var decodedCookie = decodeURIComponent(document.cookie).split(';');
        var cookieVal = '';
        decodedCookie.map(function (c) {
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                cookieVal = c.substring(name.length, c.length);
            }
        });
        if (cookieVal) {
            var zipcodecookie = cookieVal.split('|').filter(function (part) {
                return part.split("=") && (part.split("=")[0] === 'zipCode' || part.split("=")[0] === 'zip') && part.split("=")[1];
            }).map(function (filter) { return filter.replace(filter.split("=")[0] + "=", ''); });
            return zipcodecookie && zipcodecookie[0];
        }
        return null;
    };
    Utilities.getCookie = function (cname) {
        var name = cname + '=';
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var _i = 0, ca_1 = ca; _i < ca_1.length; _i++) {
            var value = ca_1[_i];
            while (value.charAt(0) === ' ') {
                value = value.substring(1);
            }
            if (value.indexOf(name) === 0) {
                return value.substring(name.length, value.length);
            }
        }
        return null;
    };
    Utilities.convertClassToIcon = function (name, prefix) {
        if (name === void 0) { name = ''; }
        if (prefix === void 0) { prefix = 'attIconWireless'; }
        var iconName = name.trim();
        try {
            // only first word matters if there is a space
            // and nothing after underscore is relevant
            iconName = iconName.split(/(_| )/)[0];
            // if name starts with icon-, format will be icon-category-iconName
            // then take the substring after the second -
            iconName = iconName.startsWith('icon-') ? iconName.slice(iconName.indexOf('-', 5) + 1) : iconName;
            // strip capital L or DS2 from end if present
            iconName = iconName.replace(/(L|DS2)$/, '');
            // capitalize appropriate letters per class image to CSS behavior
            iconName = iconName.split('-').map(function (word) { return word && (word.charAt(0).toUpperCase() + word.slice(1)); }).join('');
        }
        catch (e) {
            console.error('Error generating icon name from class :' + iconName);
        }
        return iconName ? "" + prefix + iconName : '';
    };
    Utilities.getIconFromClass = function (name, coll, prefix) {
        if (prefix === void 0) { prefix = 'attIconWireless'; }
        return coll[Utilities.convertClassToIcon(name, prefix)];
    };
    // gets URL prefix to send data to analytics based on flowType
    Utilities.getPrefix = function () {
        return Utilities.getWirelessType() === 'POSTPAID' ? '/buy/wireless/' : '/buy/wireless/prepaid/';
    };
    Utilities.getWirelessType = function () {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var baseURL = stateManager.get(WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_URL_KEY);
        return (baseURL && baseURL.url && baseURL.url.includes('prepaid')) ?
            "PREPAID" /* PREPAID */ : "POSTPAID" /* POSTPAID */;
    };
    Utilities.getSelectedCTNsOnUpgradeFlow = function () {
        var retVal = new Array();
        var cartResponse = StateProvider_1.StateProvider.getStateManagerInstance().get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        if (!Utilities.isEmptyObject(cartResponse) &&
            Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs') &&
            !Utilities.isEmptyObject(cartResponse.content.payload.wirelessCart.losgs)) {
            Object.values(cartResponse.content.payload.wirelessCart.losgs).forEach(function (value) {
                if (value && value.losgType && value.losgType === 'UP' && value._extraParams &&
                    value._extraParams.associatedCtn) {
                    retVal.push(value._extraParams.associatedCtn);
                }
            });
        }
        if (retVal.length < 1) {
            retVal = undefined;
        }
        return retVal;
    };
    Utilities.isUpgradeFlow = function () {
        if (Utilities.getSelectedCTNsOnUpgradeFlow()) {
            return true;
        }
        else {
            var stateManagerInstance = StateProvider_1.StateProvider.getStateManagerInstance();
            var wlsIntent = stateManagerInstance.get(WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE, WirelessConstants_1.WirelessConstants.APPSHELL_WIRELESS_INTENT);
            if (wlsIntent && typeof wlsIntent.wirelessIntent === 'string') {
                return wlsIntent.wirelessIntent.toLowerCase() === WirelessConstants_1.WirelessConstants.WIRELESS_UPGRADE_FLOW.toLowerCase();
            }
            else {
                // Intent not found on initial state. So getting intent from baseURL
                var getIntentURL = this.getIntentFromBaseURL();
                if (getIntentURL === WirelessConstants_1.WirelessConstants.WIRELESS_UPGRADE_FLOW.toLowerCase()) {
                    this.setIntentIfNotFoundInSession('DSUP', getIntentURL);
                    return true;
                }
                else {
                    return false;
                }
            }
        }
    };
    /**
     * @function isNewUpsellPanelEnabled
     * @description Checks if the new upsell panel is enabled or not.
     */
    Utilities.isNewUpsellPanelEnabled = function () {
        if (Utilities.isIxpFeatureEnabled('svc-enable-aal-upsell-interstitial-flow') &&
            Utilities.isUpgradeFlow() && (Utilities.getDeviceInCartCount() === 1) &&
            Utilities.getCustomerType().toUpperCase() !== 'CRU' &&
            (Utilities.getFirstLosgTypeFromCart().toUpperCase() === 'UP') &&
            !Utilities.isIxpFeatureEnabled('svc-idp-wireless-enable-progressive-upgrade-flow')) {
            var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
            var tempUpsellListForAllPromo = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_PROMO_TEMP_OFFER_LIST);
            if (!Utilities.isEmptyObject(tempUpsellListForAllPromo)) {
                var filteredOffers = tempUpsellListForAllPromo.filter(function (e) { return e.offerType !== 'tradein'; });
                if (filteredOffers.length > 0) {
                    return true;
                }
            }
        }
        return false;
    };
    Utilities.setNewUpsellDetails = function () {
        var enableUpsellInterstitial = Utilities.isNewUpsellPanelEnabled();
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        if (enableUpsellInterstitial) {
            stateManager.set(WirelessConstants_1.WirelessConstants.WIRELESS_NEW_UPSELL_CART_API, { value: true });
            var device = Utilities.createNewUpsellRequest();
            if (!Utilities.isEmptyObject(device)) {
                stateManager.set(WirelessConstants_1.WirelessConstants.WIRELESS_SELECTED_DEVICE_FOR_UPSELL, { device: device });
            }
            else {
                stateManager.set(WirelessConstants_1.WirelessConstants.WIRELESS_NEW_UPSELL_CART_API, { value: false });
            }
        }
        else {
            stateManager.set(WirelessConstants_1.WirelessConstants.WIRELESS_NEW_UPSELL_CART_API, { value: false });
        }
    };
    Utilities.createNewUpsellRequest = function () {
        var _a;
        var losg = Utilities.recentlyAddedLosg();
        if (!(losg === null || losg === void 0 ? void 0 : losg.id)) {
            return;
        }
        else {
            var lineItem = Utilities.getLosgItemFromCart(losg.id, CartActions_1.ItemType.DEVICE.toString());
            var sdgLineItem = Utilities.getLosgItemFromCart(losg.id, CartActions_1.ItemType.SHARED_DATA_GROUP.toString());
            var sdgId = sdgLineItem === null || sdgLineItem === void 0 ? void 0 : sdgLineItem.offerId;
            var ctn = Utilities.getSelectedCTNsOnUpgradeFlow();
            var device = {
                commitmentTerm: (_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.contractDetails) === null || _a === void 0 ? void 0 : _a._commitmentTermId,
                customerType: Utilities.getCustomerType(),
                existingPlanType: Utilities.getExistingPlanType(),
                flowType: 'UP',
                losgId: losg === null || losg === void 0 ? void 0 : losg.id,
                sdgId: sdgId,
                skuId: lineItem === null || lineItem === void 0 ? void 0 : lineItem.productSKU,
                subscriber: ctn ? ctn[0] : '',
                type: 'DEVICE',
            };
            return device;
        }
    };
    Utilities.getCustomerSelectedOption = function () {
        var _a;
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var selectedCtns = Utilities.getSelectedCTNsOnUpgradeFlow();
        var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        var selectedOption;
        if (Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs')) {
            selectedOption = (_a = Object.values(cartResponse.content.payload.wirelessCart.losgs).filter(function (losg) {
                return losg && losg.losgType && losg.losgType.toUpperCase() === 'UP' && losg._extraParams &&
                    losg._extraParams.associatedCtn === selectedCtns[0];
            })[0]) === null || _a === void 0 ? void 0 : _a._selectedUpgradeOption;
            switch (selectedOption) {
                case "PAYUP" /* PAYUP */:
                    return "PAYUP" /* PAYUP */;
                    break;
                case "PAYOFF" /* PAYOFF */:
                    return "PAYOFF" /* PAYOFF */;
                    break;
                case "REGULAR" /* REGULAR */:
                    return "REGULAR" /* REGULAR */;
                    break;
                default:
                    return selectedOption;
                    break;
            }
        }
        return selectedOption;
    };
    // for supressing pick something else button in newUpsell panel
    Utilities.newUpsellPanelHideBtn = function (losgId) {
        var hidePanelButton = false;
        if (Utilities.isIxpFeatureEnabled('svc-enable-aal-upsell-interstitial-flow') &&
            Utilities.isUpgradeFlow() && (Utilities.getDeviceInCartCount() === 2) &&
            (Utilities.getFirstLosgTypeFromCart().toUpperCase() === 'UP') &&
            !Utilities.isIxpFeatureEnabled('svc-idp-wireless-enable-progressive-upgrade-flow')) {
            var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
            var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
            if (Utilities.isUpgradeFlow() && Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs') &&
                !Utilities.isEmptyObject(cartResponse.content.payload.wirelessCart.losgs)) {
                Object.values(cartResponse.content.payload.wirelessCart.losgs).forEach(function (losg) {
                    if (losg.id === losgId && losg.losgType === 'AL') {
                        hidePanelButton = true;
                    }
                });
            }
        }
        return hidePanelButton;
    };
    Utilities.getIntentFromBaseURL = function () {
        var baseURL = StateProvider_1.StateProvider.getStateManagerInstance().get(WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_URL_KEY);
        var appShellBaseURL = baseURL ? baseURL.url.toLowerCase() : window.location.href.toLowerCase();
        var filter = new RegExp('[?&]wlsfi=([^&#]*)');
        var paramValue = filter.exec(appShellBaseURL);
        return Array.isArray(paramValue) && paramValue.length > 0 ? paramValue[1] : null;
    };
    Utilities.setIntentIfNotFoundInSession = function (intent, wirelessIntent) {
        StateProvider_1.StateProvider.getStateManagerInstance().set(WirelessConstants_1.WirelessConstants.WIRELESS_IDSE_FLOW_SELECTED, { intent: intent });
        window.sessionStorage.setItem('appShell:IDSEIntent', JSON.stringify({ wirelessIntent: wirelessIntent }));
    };
    Utilities.isEapSet = function () {
        var wlsEap = StateProvider_1.StateProvider.getStateManagerInstance()
            .getForProxy(WirelessConstants_1.WirelessConstants.WIRELESS_EAP_FLOW);
        return (wlsEap && wlsEap.eapFlow &&
            wlsEap.eapFlow.search(WirelessConstants_1.WirelessConstants.WIRELESS_EAP_FLOW) > -1);
    };
    Utilities.getAuthDetails = function () {
        var wireLSAuthDetails = StateProvider_1.StateProvider.getStateManagerInstance().get(WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE, WirelessConstants_1.WirelessConstants.APPSHELL_WIRELESS_AUTH_DETAILS);
        return wireLSAuthDetails;
    };
    Utilities.isPlanGRPContainsMNMLLPFPlan = function (wlsAuthDetails) {
        if (wlsAuthDetails.accountDetails && wlsAuthDetails.accountDetails.planGroups) {
            var planGroups = wlsAuthDetails.accountDetails.planGroups;
            var isNotMnmLLp = function (currentValue) { return (currentValue.isMnM === false &&
                currentValue.isLLP === false); };
            var noMnmLLpExists = !Utilities.isEmptyObject(wlsAuthDetails.accountDetails) &&
                !Utilities.isEmptyObject(planGroups) && planGroups.length > 0 && planGroups.every(isNotMnmLLp);
            return noMnmLLpExists && this.isFamilyPlanConsistent(planGroups);
        }
        return false;
    };
    Utilities.isMnmLLPFTNotExists = function () {
        var wlsAuthDetails = this.getAuthDetails();
        if (wlsAuthDetails && wlsAuthDetails.showJoinGroup === true &&
            !Utilities.isIxpFeatureEnabled('svc-idp-wireless-enable-mix-n-match-plans')) {
            return this.isPlanGRPContainsMNMLLPFPlan(wlsAuthDetails);
        }
        return false;
    };
    Utilities.getPlanGRPMNMORLLPORLEGACY = function () {
        var existingJGPlan = StateProvider_1.StateProvider.getStateManagerInstance().get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_EXIST_PLAN_TYPE_JG);
        return existingJGPlan.value;
    };
    Utilities.getJGExistingPlanTypeForUP = function (shareDataCode, wlsAuthDetails) {
        var _a, _b, _c, _d;
        if ((wlsAuthDetails === null || wlsAuthDetails === void 0 ? void 0 : wlsAuthDetails.accountDetails) && ((_a = wlsAuthDetails === null || wlsAuthDetails === void 0 ? void 0 : wlsAuthDetails.accountDetails) === null || _a === void 0 ? void 0 : _a.planGroups)) {
            var planGroups = (wlsAuthDetails === null || wlsAuthDetails === void 0 ? void 0 : wlsAuthDetails.accountDetails) && ((_b = wlsAuthDetails === null || wlsAuthDetails === void 0 ? void 0 : wlsAuthDetails.accountDetails) === null || _b === void 0 ? void 0 : _b.planGroups);
            var selectedPlanGroup = planGroups.filter(function (pg) { return (pg === null || pg === void 0 ? void 0 : pg.billCode) === shareDataCode; });
            if (selectedPlanGroup && ((_c = selectedPlanGroup[0]) === null || _c === void 0 ? void 0 : _c.isMnM)) {
                return 'MnM';
            }
            else if (selectedPlanGroup && ((_d = selectedPlanGroup[0]) === null || _d === void 0 ? void 0 : _d.isLLP)) {
                return 'LLP';
            }
            else {
                return 'Legacy';
            }
        }
        return 'Legacy';
    };
    Utilities.getExistingPlanType = function () {
        var _a, _b;
        var authDetails = Utilities.getAuthDetails();
        if ((_a = authDetails === null || authDetails === void 0 ? void 0 : authDetails.planItemBean) === null || _a === void 0 ? void 0 : _a.isMnM) {
            return 'MnM';
        }
        else if ((_b = authDetails === null || authDetails === void 0 ? void 0 : authDetails.planItemBean) === null || _b === void 0 ? void 0 : _b.isLLP) {
            return 'LLP';
        }
        else if (Utilities.isLegacyAccount()) {
            return 'Legacy';
        }
        else {
            return Utilities.getPlanGRPMNMORLLPORLEGACY() || 'Legacy';
        }
    };
    Utilities.isFamilyPlanConsistent = function (planGroups) {
        var allSame = planGroups.map(function (ele) { return ele.familyPlan; });
        var consistent = allSame.every(function (val, i, arr) { return val === arr[0]; });
        return consistent;
    };
    Utilities.isLegacyAccount = function () {
        var authDetails = StateProvider_1.StateProvider.getStateManagerInstance().get(WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE, WirelessConstants_1.WirelessConstants.APPSHELL_WIRELESS_AUTH_DETAILS);
        return authDetails && Utilities.isKeyExist(authDetails, 'planItemBean.isMnM') && Utilities.isKeyExist(authDetails, 'planItemBean.isLLP')
            && authDetails.planItemBean.isMnM === false && authDetails.planItemBean.isLLP === false;
    };
    Utilities.isNewAALandMnM = function () {
        return ((Utilities.isAALFlow() || Utilities.isNewFlow()) &&
            Utilities.isIxpFeatureEnabled('svc-idp-wireless-enable-mix-n-match-plans')) ? true : false;
    };
    Utilities.isAALFlow = function () {
        var wlsIntent = StateProvider_1.StateProvider.getStateManagerInstance().get(WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE, WirelessConstants_1.WirelessConstants.APPSHELL_WIRELESS_INTENT);
        return (wlsIntent && wlsIntent.wirelessIntent &&
            wlsIntent.wirelessIntent.search(WirelessConstants_1.WirelessConstants.WIRELESS_AAL_FLOW) > -1);
    };
    Utilities.isNewFlow = function () {
        var wlsIntent = StateProvider_1.StateProvider.getStateManagerInstance().get(WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE, WirelessConstants_1.WirelessConstants.APPSHELL_WIRELESS_INTENT);
        return (wlsIntent && wlsIntent.wirelessIntent &&
            wlsIntent.wirelessIntent.search(WirelessConstants_1.WirelessConstants.WIRELESS_NEW_FLOW) > -1);
    };
    Utilities.isIntentSet = function () {
        var wlsIntent = StateProvider_1.StateProvider.getStateManagerInstance().get(WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE, WirelessConstants_1.WirelessConstants.APPSHELL_WIRELESS_INTENT);
        return (wlsIntent && wlsIntent.wirelessIntent) ? true : false;
    };
    Utilities.isWlsPreAuth = function () {
        var wlsIntent = StateProvider_1.StateProvider.getStateManagerInstance().get(WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE, WirelessConstants_1.WirelessConstants.APPSHELL_WIRELESS_INTENT);
        var profileInfo = StateProvider_1.StateProvider.getStateManagerInstance().get(WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE, WirelessConstants_1.WirelessConstants.APPSHELL_WIRELESS_CUSTOMER_PROFILE_INFO);
        if (!wlsIntent && profileInfo && profileInfo.content
            && profileInfo.content.customerState === 'Authenticated') {
            if (profileInfo.content.linkedWirelessAccNums && profileInfo.content.linkedWirelessAccNums.length > 0) {
                return true;
            }
        }
        return false;
    };
    Utilities.isNonWlsPreAuth = function () {
        var wlsIntent = StateProvider_1.StateProvider.getStateManagerInstance().get(WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE, WirelessConstants_1.WirelessConstants.APPSHELL_WIRELESS_INTENT);
        var profileInfo = StateProvider_1.StateProvider.getStateManagerInstance().get(WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE, WirelessConstants_1.WirelessConstants.APPSHELL_WIRELESS_CUSTOMER_PROFILE_INFO);
        if (!wlsIntent && profileInfo && profileInfo.content
            && profileInfo.content.customerState === 'Authenticated') {
            if (!profileInfo.content.linkedWirelessAccNums || profileInfo.content.linkedWirelessAccNums.length <= 0) {
                return true;
            }
        }
        return false;
    };
    Utilities.isEAPBMWFlow = function () {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var wlsAuthDetails = stateManager.get(WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE, WirelessConstants_1.WirelessConstants.APPSHELL_WIRELESS_AUTH_DETAILS);
        if (Utilities.isKeyExist(wlsAuthDetails, 'connectedCarId')) {
            return true;
        }
        return false;
    };
    /**
     * @param pLosgId
     *
     * if losgId is present in the request and it is the same losgId in teh cart response, send the losgtype
     * from the cart, else based on the flow of the application derive the losgType and return it
     *
     */
    Utilities.getLosgType = function (pLosgId) {
        var retVal = '';
        if (Utilities.getWirelessType() === "PREPAID" /* PREPAID */) {
            return CartActions_2.LosgType.NEW;
        }
        if (pLosgId && !Utilities.isAALFlow()) {
            var cartResponse = StateProvider_1.StateProvider.getStateManagerInstance().get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
            if (Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs') &&
                cartResponse.content.payload.wirelessCart.losgs[pLosgId]) {
                retVal = cartResponse.content.payload.wirelessCart.losgs[pLosgId].losgType;
            }
        }
        if (!retVal) {
            retVal = this.getDerivedLosgType();
        }
        return retVal;
    };
    /**
     * @function isAccountEligibleForNextUp
     * @description Method for finding any account level or flag level
     * eligibility for NextUp Promo Offers
     */
    Utilities.isAccountEligibleForNextUp = function () {
        if (Utilities.isUpgradeFlow() &&
            Utilities.isIxpFeatureEnabled('svc-enable-next-up-tradein') &&
            Utilities.isIxpFeatureEnabled('svc-idp-stc-nextup-enabled')) {
            return true;
        }
        return false;
    };
    /**
     * @function isAccountEligibleForHylaTradeInToggle
     * @description Method for finding any account level or flag level
     * eligibility for Hyla TradeIn Toggle in AAL and Upgrade FLow
     * @returns boolean
     */
    Utilities.isAccountEligibleForHylaTradeInToggle = function () {
        if (((Utilities.isUpgradeFlow() && (Utilities.getCustomerSelectedOption() === 'REGULAR'
            || Utilities.getCustomerSelectedOption() === 'PAYOFF')) || Utilities.isAALFlow()) &&
            Utilities.isIxpFeatureEnabled('svc-pcv1-enable-tradein-toggle-display') && !Utilities.isSMBCRUUser()) {
            return true;
        }
        return false;
    };
    /**
     * @function isAccountEligibleForHylaTradeInToggle
     * @description Sending New offer type in API
     * eligibility for Hyla TradeIn Toggle in AAL and Upgrade Flow
     * @returns boolean
     */
    Utilities.isAccountEligibleForHylaTradeInApi = function () {
        if ((Utilities.isUpgradeFlow() || Utilities.isAALFlow()) &&
            Utilities.isIxpFeatureEnabled('svc-pcv1-enable-tradein-toggle-display') &&
            !Utilities.isSMBCRUUser()) {
            return true;
        }
        return false;
    };
    /**
     * @function getPromoType
     * @param promoReason
     * @description Gets the PromoType according to product promoType.
     * @returns PromoType
     */
    Utilities.getPromoType = function (promoReason) {
        if (promoReason) {
            switch (promoReason) {
                case 'regularTradeIn':
                    return Device_1.PromoType.TradeIn;
                case 'standalone':
                    return Device_1.PromoType.Standalone;
                case 'nextUpTradeIn':
                    return Device_1.PromoType.NextUp;
                default:
                    return Device_1.PromoType.Regular;
            }
        }
        return Device_1.PromoType.Regular;
    };
    /**
     *
     * @param product
     * @returns boolean
     */
    Utilities.regularTradeIN = function (product) {
        var isRegularTradeIn = false;
        if (Utilities.isKeyExist(product, 'promoPricing')) {
            var promoPricing = product.promoPricing;
            promoPricing && promoPricing.map(function (e) {
                if (e.promoType && e.promoType === 'tradein' &&
                    e.tradeInEligibilityReason && e.tradeInEligibilityReason === 'regularTradeIn') {
                    isRegularTradeIn = true;
                }
            });
        }
        return isRegularTradeIn;
    };
    /**
     * @function getPricingDetails
     * @desc Checks if the device is eleiglble for NextUp,
     * tradeIn and standalone offers for HylaToggle and Nextup
     * @param priceOption
     */
    Utilities.getPricingDetails = function (product) {
        var _a, _b, _c, _d, _e;
        var pricing;
        var OriginalnetPrice = product === null || product === void 0 ? void 0 : product.netPrice;
        var OriginalPromoPrice = product === null || product === void 0 ? void 0 : product.promoPrice;
        if (Utilities.isKeyExist(product, 'promoPricing')) {
            var promoPricing = product === null || product === void 0 ? void 0 : product.promoPricing;
            if ((promoPricing === null || promoPricing === void 0 ? void 0 : promoPricing.length) >= 1) {
                var nextTradeInPromo = promoPricing && promoPricing.filter(function (e) {
                    return e.promoType && e.promoType === 'tradein' &&
                        e.tradeInEligibilityReason && e.tradeInEligibilityReason === 'nextTradeIn';
                });
                var standalonePromo = promoPricing && promoPricing.filter(function (e) {
                    return e.promoType && e.promoType === 'standalone';
                });
                var regularTradeInPromo = promoPricing && promoPricing.filter(function (e) {
                    return e.promoType && e.promoType === 'tradein' &&
                        e.tradeInEligibilityReason && e.tradeInEligibilityReason === 'regularTradeIn';
                });
                if (Utilities.getHylaTradeInIntent()) {
                    var marketingPromoPrice = void 0;
                    if (regularTradeInPromo.length !== 0) {
                        marketingPromoPrice = regularTradeInPromo.sort(function (promo1, promo2) { return parseInt(promo1 === null || promo1 === void 0 ? void 0 : promo1.marketingPriority) - parseInt(promo2 === null || promo2 === void 0 ? void 0 : promo2.marketingPriority); });
                        return pricing = {
                            netPrice: OriginalnetPrice,
                            promoPrice: (marketingPromoPrice && ((_a = marketingPromoPrice[0]) === null || _a === void 0 ? void 0 : _a.monthlyPromoPrice) <= 0) ? '0.00' : marketingPromoPrice && ((_b = marketingPromoPrice[0]) === null || _b === void 0 ? void 0 : _b.monthlyPromoPrice),
                            promoType: Device_1.PromoType.Regular,
                        };
                    }
                }
                if (nextTradeInPromo.length !== 0) {
                    var promoPriceing = nextTradeInPromo.
                        sort(function (promo1, promo2) { return parseInt(promo1 === null || promo1 === void 0 ? void 0 : promo1.marketingPriority) - parseInt(promo2 === null || promo2 === void 0 ? void 0 : promo2.marketingPriority); });
                    return pricing = {
                        netPrice: OriginalnetPrice,
                        promoPrice: promoPriceing && ((_c = promoPriceing[0]) === null || _c === void 0 ? void 0 : _c.monthlyPromoPrice),
                        promoType: Device_1.PromoType.NextUp,
                    };
                }
                if (standalonePromo.length !== 0) {
                    var marketPrice = standalonePromo.sort(function (promo1, promo2) { return parseInt(promo1 === null || promo1 === void 0 ? void 0 : promo1.marketingPriority) - parseInt(promo2 === null || promo2 === void 0 ? void 0 : promo2.marketingPriority); });
                    return pricing = {
                        netPrice: OriginalnetPrice,
                        promoPrice: (marketPrice && ((_d = marketPrice[0]) === null || _d === void 0 ? void 0 : _d.monthlyPromoPrice) <= 0) ? '0.00' : marketPrice && ((_e = marketPrice[0]) === null || _e === void 0 ? void 0 : _e.monthlyPromoPrice),
                        promoType: Device_1.PromoType.Standalone,
                    };
                }
            }
        }
        return pricing = {
            netPrice: OriginalnetPrice,
            promoType: Device_1.PromoType.Regular,
            promoPrice: OriginalPromoPrice,
        };
    };
    Utilities.getDerivedLosgType = function () {
        var retVal;
        if (Utilities.isAALFlow()) {
            retVal = CartActions_2.LosgType.AL;
        }
        else if (Utilities.isUpgradeFlow()) {
            var upSellStorage = new Map(StateProvider_1.StateProvider.getStateManagerInstance()
                .get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_PROMO_STORAGE));
            var offerInfo = StateProvider_1.StateProvider.getStateManagerInstance().get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_PROMO_TEMP_OFFER);
            var nextSelections = upSellStorage && offerInfo && offerInfo[0]
                && offerInfo[0].id && upSellStorage.get(offerInfo[0].id);
            var bogodetails = nextSelections && nextSelections.
                filter(function (e) { return e && e.offerType &&
                (e.offerType.toUpperCase() === 'BOGO' || e.offerType.toUpperCase() === 'UPSELL'); });
            if (bogodetails && bogodetails[0] && bogodetails[0].losgTypes &&
                nextSelections && nextSelections[0] && nextSelections[0].losgTypes && nextSelections[0].losgTypes[0]) {
                retVal = nextSelections[0].losgTypes[0];
            }
            else {
                retVal = CartActions_2.LosgType.UP;
            }
        }
        else {
            retVal = CartActions_2.LosgType.NEW;
        }
        return retVal;
    };
    Utilities.getWirelessConsoleData = function () {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var nameSpace = WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE;
        if (this.getWirelessType() === "PREPAID" /* PREPAID */ || this.isUpgradeFlow()) {
            nameSpace = WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE;
        }
        return stateManager.get(nameSpace, WirelessConstants_1.WirelessConstants.APPSHELL_WIRELESS_CATALOG_RESPONSE_KEY);
    };
    Utilities.getWirelessSubFlow = function () {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var wirelessDetails = stateManager.get(WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_DETAILS);
        var wirelessSubFlow = "DEVICESFIRST" /* DEVICESFIRST */;
        if (wirelessDetails && wirelessDetails.wirelessType === "PREPAID" /* PREPAID */.toLowerCase()) {
            wirelessSubFlow = "BYOD" /* BYOD */;
        }
        if (wirelessDetails && wirelessDetails.experienceType === 'plansfirst' &&
            (Utilities.isFeatureEnabled('enable-postpaid-plansfirst-flow') ||
                Utilities.isFeatureEnabled('enable-prepaid-plansfirst-flow'))) {
            wirelessSubFlow = "PLANSFIRST" /* PLANSFIRST */;
        }
        else if (wirelessDetails && wirelessDetails.experienceType === 'devicesfirst' &&
            (Utilities.isFeatureEnabled('enable-prepaid-devicesfirst-flow'))) {
            wirelessSubFlow = "DEVICESFIRST" /* DEVICESFIRST */;
        }
        else if (wirelessDetails && wirelessDetails.experienceType === 'onDevice') {
            wirelessSubFlow = "ONDEVICE" /* ON_DEVICE */;
        }
        return wirelessSubFlow;
    };
    Utilities.getIRUInfo = function () {
        var cookieInfo = Utilities.getCookie('GNSESS');
        if (cookieInfo && cookieInfo.includes('FANID')) {
            return Utilities.getCookie('GNSESS');
        }
        return null;
    };
    Utilities.getUrlParamValue = function (field, url) {
        var filter = new RegExp('[?&]' + field + '=([^&#]*)');
        var paramValue = filter.exec(url);
        return paramValue ? paramValue[1] : null;
    };
    Utilities.getDeviceCMSRoute = function (_a) {
        var skuId = _a.skuId;
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var mapping = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_DEVICE_CMS_MAPPING);
        var cmsfeed;
        if (!Utilities.isEmptyObject(mapping)) {
            cmsfeed = (mapping[skuId] || '').trim();
        }
        return {
            key: cmsfeed && cmsfeed.split(/\/|\./).slice(-3)[0],
            url: cmsfeed,
        };
    };
    Utilities.getAccessoryCMSRoute = function (_a) {
        var skuId = _a.skuId;
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var mapping = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_ACCESSORY_CMS_MAPPING);
        var cmsfeed = (mapping[skuId] || '').trim();
        return {
            key: Utilities.getKeyFromUrl(cmsfeed),
            url: cmsfeed,
        };
    };
    Utilities.getKeyFromUrl = function (url) {
        return url.split(/\/|\./).slice(-3)[0];
    };
    /** Validates content can be displayed */
    Utilities.validRichContent = function (text) {
        var temp = document.createElement('div');
        var content = decodeURIComponent(encodeURI(text));
        temp.innerHTML = content;
        return this.isApprovedContent(Array.prototype.slice.call(temp.querySelectorAll('*')))
            ? content : 'INVALID';
    };
    Utilities.getFlowCode = function () {
        var isEAPOnDevice = Utilities.getWirelessSubFlow() === "ONDEVICE" /* ON_DEVICE */;
        var flowCode;
        if (Utilities.isNewFlow() && (Utilities.isEapSet() || isEAPOnDevice)) {
            flowCode = 'EANEW';
        }
        else if (Utilities.isAALFlow() && (Utilities.isEapSet() || isEAPOnDevice || Utilities.isEAPBMWFlow())) {
            flowCode = 'EAAL';
        }
        else if (Utilities.isOnlyAccessoryInCart()) {
            flowCode = 'DSACC';
        }
        else {
            if (Utilities.isAALFlow()) {
                flowCode = 'DSAAL';
            }
            else if (Utilities.isUpgradeFlow()) {
                if (Utilities.isMixedCart()) {
                    flowCode = 'DSAAL|DSUP';
                }
                else {
                    flowCode = 'DSUP';
                }
            }
            else {
                flowCode = 'DSNEW';
            }
        }
        return flowCode;
    };
    Utilities.getDeviceInCartCount = function (cartResponse) {
        var deviceCount = 0;
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        // tslint:disable-next-line:max-line-length
        cartResponse = cartResponse ? cartResponse : stateManager.getForProxy(WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        if (Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs')) {
            var losgs = Object.values(cartResponse.content.payload.wirelessCart.losgs);
            for (var _i = 0, losgs_4 = losgs; _i < losgs_4.length; _i++) {
                var losg = losgs_4[_i];
                var lineItems = Utilities.isEmptyObject(losg.lineItems) ? null : Object.values(losg.lineItems);
                if (lineItems) {
                    for (var _a = 0, lineItems_4 = lineItems; _a < lineItems_4.length; _a++) {
                        var lineItem = lineItems_4[_a];
                        if (lineItem._itemType === 'device') {
                            deviceCount += 1;
                        }
                    }
                }
            }
        }
        return deviceCount;
    };
    Utilities.getDeviceNameFromCart = function (props) {
        var _a;
        var deviceName = null;
        if (Utilities.isKeyExist(props, 'data.losg.lineItems')) {
            var deviceItem = Object.values(props.data.losg.lineItems)
                .find(function (item) { return item && item._itemType ? item._itemType.toUpperCase() === 'DEVICE' : false; });
            if (deviceItem) {
                deviceName = (_a = deviceItem.hardGood) === null || _a === void 0 ? void 0 : _a.model;
            }
        }
        return deviceName;
    };
    Utilities.isDeviceInCart = function (cartResponse) {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var cartResponseKey = cartResponse ?
            cartResponse :
            stateManager.getForProxy(WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        if (cartResponseKey === null) {
            return false;
        }
        var wirelessCart = Utilities.isKeyExist(cartResponseKey, 'content.payload.wirelessCart') &&
            cartResponseKey.content.payload.wirelessCart;
        var findDevice = false;
        if ((!wirelessCart._paymentType && Utilities.getWirelessType() === "POSTPAID" /* POSTPAID */)
            || (wirelessCart._paymentType && Utilities.getWirelessType() === "PREPAID" /* PREPAID */)) {
            var losgs = Utilities.isKeyExist(wirelessCart, 'losgs') && Object.values(wirelessCart.losgs);
            for (var _i = 0, losgs_5 = losgs; _i < losgs_5.length; _i++) {
                var losg = losgs_5[_i];
                var firstLineWithDevice = Utilities.isEmptyObject(losg.lineItems) ? null :
                    Object.values(losg.lineItems)
                        .find(function (line) { return (line && line._itemType && line._itemType.toLowerCase() === 'device') ||
                        (line && line.itemType && line.itemType.toLowerCase() === 'device'); });
                if (firstLineWithDevice) {
                    findDevice = true;
                }
            }
        }
        return findDevice;
    };
    Utilities.isAccessoryInCart = function (cartResponse) {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var cartResponseKey = cartResponse ? cartResponse :
            stateManager.getForProxy(WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        var wirelessCart = Utilities.isKeyExist(cartResponseKey, 'content.payload.wirelessCart') &&
            cartResponseKey.content.payload.wirelessCart;
        var findAccessory = false;
        var losgs = Utilities.isKeyExist(wirelessCart, 'losgs') && Object.values(wirelessCart.losgs);
        for (var _i = 0, losgs_6 = losgs; _i < losgs_6.length; _i++) {
            var losg = losgs_6[_i];
            var lineWithAccessory = losg.lineItems && Object.values(losg.lineItems)
                .find(function (line) { return (line && line._itemType && line._itemType.toLowerCase() === 'accessory') ||
                (line && line.itemType && line.itemType.toLowerCase() === 'accessory'); });
            if (lineWithAccessory) {
                findAccessory = true;
            }
        }
        return findAccessory;
    };
    Utilities.isOnlyAccessoryInCart = function (cartResponse) {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var cartResponseKey = cartResponse ? cartResponse :
            stateManager.getForProxy(WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        var notOnlyAccessory = true;
        var wirelessCart = Utilities.isKeyExist(cartResponseKey, 'content.payload.wirelessCart') &&
            cartResponseKey.content.payload.wirelessCart;
        if (wirelessCart) {
            notOnlyAccessory = false;
            var losgs = Utilities.isKeyExist(wirelessCart, 'losgs') && Object.values(wirelessCart.losgs);
            for (var _i = 0, losgs_7 = losgs; _i < losgs_7.length; _i++) {
                var losg = losgs_7[_i];
                if (losg.losgType !== CartActions_2.LosgType.ACC) {
                    notOnlyAccessory = true;
                }
            }
        }
        return !notOnlyAccessory;
    };
    Utilities.isDeviceInCartByodSim = function (byodSimOfferId) {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var cartResponse = stateManager.getForProxy(WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        if (cartResponse === null) {
            return false;
        }
        var wirelessCart = Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart') &&
            cartResponse.content.payload.wirelessCart;
        var losgs = Utilities.isKeyExist(wirelessCart, 'losgs') && Object.values(wirelessCart.losgs);
        for (var _i = 0, losgs_8 = losgs; _i < losgs_8.length; _i++) {
            var losg = losgs_8[_i];
            var firstLineWithDeviceSimOnlu = Object.values(losg.lineItems)
                .find(function (line) { return line._itemType === 'device' && line.productCode === byodSimOfferId; });
            if (firstLineWithDeviceSimOnlu) {
                return true;
            }
            return false;
        }
        return false;
    };
    Utilities.getLosgItemForInterstetialPage = function () {
        var cartResponse = Utilities.getCartResponse();
        var losgs = Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs') &&
            cartResponse.content.payload.wirelessCart.losgs;
        var arrLosg = Object.values(losgs);
        return arrLosg.find(function (obj) { return obj.losgType === 'AL'; });
    };
    Utilities.getOfferCodeForInterstetialPage = function (losgId) {
        var _a;
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var hylaFromSM = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_HYLA_TRADEIN);
        var offerCode = !Utilities.isEmptyObject(hylaFromSM) && hylaFromSM.length > 0 && ((_a = hylaFromSM.find(function (offer) { return offer.losgId === losgId && offer.tradeIn && offer.tradeIn === true; })) === null || _a === void 0 ? void 0 : _a.offerCode);
        return offerCode;
    };
    /**
     * @function getReadyToCheckOutStatus
     * @description Check if cart is ready
     * to checkout based on cart status
     * @returns boolean
     */
    Utilities.getReadyToCheckOutStatus = function () {
        var _a, _b, _c, _d, _e, _f;
        var cartResponse = Utilities.getCartResponse();
        if (!Utilities.isEmptyObject(cartResponse) &&
            ((_c = (_b = (_a = cartResponse === null || cartResponse === void 0 ? void 0 : cartResponse.content) === null || _a === void 0 ? void 0 : _a.payload) === null || _b === void 0 ? void 0 : _b.cartStatus) === null || _c === void 0 ? void 0 : _c.readyToCheckout) === true &&
            ((_f = (_e = (_d = cartResponse === null || cartResponse === void 0 ? void 0 : cartResponse.content) === null || _d === void 0 ? void 0 : _d.payload) === null || _e === void 0 ? void 0 : _e.cartStatus) === null || _f === void 0 ? void 0 : _f.cartState) === 'COMPLETE') {
            return true;
        }
        return false;
    };
    Utilities.getCartRedirectToCheckoutStatus = function () {
        var cartResponse = Utilities.getCartResponse();
        var cartPayload = cartResponse.content.payload;
        var redirectToCheckout = (cartPayload && Utilities.isKeyExist(cartPayload, 'wirelessCart._skipCart')) ? cartPayload.wirelessCart._skipCart : false;
        return redirectToCheckout;
    };
    Utilities.getLosgCount = function () {
        var cartResponse = Utilities.getCartResponse();
        var losgs = Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs') &&
            cartResponse.content.payload.wirelessCart.losgs;
        return (losgs ? Object.values(losgs).length : 0);
    };
    Utilities.getLosgIdArray = function () {
        var _a, _b, _c, _d;
        var cartResponse = Utilities.getCartResponse();
        var losgs = Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs') &&
            cartResponse.content.payload.wirelessCart.losgs;
        var losgIdArray = [];
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var changeLosg = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.CHANGEDEVICE_LOSG);
        if (losgs) {
            if (changeLosg && changeLosg.losg) {
                losgIdArray = (_b = (_a = Object.values(losgs)) === null || _a === void 0 ? void 0 : _a.filter(function (losg) {
                    return (!Utilities.isEmptyObject(losg === null || losg === void 0 ? void 0 : losg.lineItems) && changeLosg.losg != losg.id);
                })) === null || _b === void 0 ? void 0 : _b.map(function (losg) { return losg === null || losg === void 0 ? void 0 : losg.id; });
            }
            else {
                losgIdArray = (_d = (_c = Object.values(losgs)) === null || _c === void 0 ? void 0 : _c.filter(function (losg) {
                    return !Utilities.isEmptyObject(losg === null || losg === void 0 ? void 0 : losg.lineItems);
                })) === null || _d === void 0 ? void 0 : _d.map(function (losg) { return losg === null || losg === void 0 ? void 0 : losg.id; });
            }
        }
        return losgIdArray;
    };
    /**
     * @function getCartResponse
     * @description gets cart response from session
     * @returns CartResponse | null
     */
    Utilities.getCartResponse = function () {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var cartResponse = stateManager.getForProxy(WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        if (cartResponse && cartResponse.content && cartResponse.content.payload) {
            return cartResponse;
        }
        else {
            return null;
        }
    };
    Utilities.getUserAccountInfo = function () {
        var userSessionInfo = JSON.parse(sessionStorage.getItem('customerInfoSDK'));
        if (Utilities.isSMBCRUUser()) {
            return {
                'user.account.liabilityType': 'CRU',
                'user.customerType': 'SMB',
                'user.login.userType': 'SMB',
            };
        }
        else {
            if (userSessionInfo && userSessionInfo['user.login.userType'] && userSessionInfo['user.login.userType'] === 'CONS_SMB') {
                if (userSessionInfo['user.account.accountInFocusUserType'] && userSessionInfo['user.account.accountInFocusUserType'] === 'SMB') {
                    return {
                        'user.account.liabilityType': 'CRU',
                        'user.customerType': 'SMB',
                        'user.login.userType': 'CONS_SMB',
                    };
                }
                else if (userSessionInfo['user.account.accountInFocusUserType'] && userSessionInfo['user.account.accountInFocusUserType'] === 'CONS') {
                    return {
                        'user.account.liabilityType': 'CONS',
                        'user.customerType': 'CONS',
                        'user.login.userType': 'CONS_SMB',
                    };
                }
            }
        }
        return {};
    };
    Utilities.getNextIntendedDeviceType = function () {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var intendedDevices = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_INTENDED_DEVICES);
        if (!Utilities.isEmptyObject(intendedDevices) && intendedDevices instanceof Array) {
            return intendedDevices.find(function (intendedDevice) {
                return intendedDevice.isAddedToCart === false;
            });
        }
    };
    Utilities.intendedDevicesAddedToCart = function () {
        var flag = false;
        // Execute this block only for postpaid plan first flow.
        if (this.getWirelessType() === "POSTPAID" /* POSTPAID */ &&
            this.getWirelessSubFlow() === "PLANSFIRST" /* PLANSFIRST */) {
            var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
            // To get the current intended device count configuration.
            var currentIntendedDevices = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_INTENDED_DEVICES);
            // To get the next intended device to be added.
            var nextIntendedDeviceToBeAdded = this.getNextIntendedDeviceType();
            // To get the initial intended device count coming in URL as query param.
            var deviceCountComingInUrl = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_INITIAL_INTENDED_DEVICE_COUNT);
            var intendedDevicesAddedToCart = [];
            if (!this.isEmptyObject(currentIntendedDevices)) {
                // Check for the already added devices from intended devices.
                intendedDevicesAddedToCart = currentIntendedDevices.filter(function (device) {
                    return device.isAddedToCart === true;
                });
            }
            if (!this.isEmptyObject(currentIntendedDevices)) {
                /**
                 * Check if initial device count requested in query param is equal to device added in cart.
                 */
                if (!this.isEmptyObject(deviceCountComingInUrl)) {
                    /**
                     * Check if device count coming in url is less then declared intended device count.
                     * and declared intended device is less then device added to cart,
                     * still we have device to add in cart, and declared intended device is not equal to 0,
                     * that means use adding plan first.
                     */
                    if (deviceCountComingInUrl.count <= intendedDevicesAddedToCart.length
                        && currentIntendedDevices.length <= intendedDevicesAddedToCart.length
                        && intendedDevicesAddedToCart.length !== 0) {
                        flag = true;
                    }
                    else if (intendedDevicesAddedToCart.length <= currentIntendedDevices.length) {
                        /**
                         * check if declared intended devices added to cart is less then declared intended device count.
                         * that means still we have something to add.
                         */
                        flag = true;
                    }
                }
                else {
                    /**
                     * if we don't have device count coming in url then
                     * check if declared intended devices added to cart is less then declared intended device count.
                     * that means still we have something to add.
                     */
                    if (intendedDevicesAddedToCart.length <= currentIntendedDevices.length) {
                        flag = true;
                    }
                }
            }
        }
        return flag;
    };
    Utilities.isPDPA2CIntent = function (flowType) {
        var flag = false;
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var baseURL = stateManager.get(WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_URL_KEY);
        var selectedDevice = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_SELECTED_DEVICE_SKU);
        if (baseURL && baseURL.url && Utilities.isFeatureEnabled('pdp-idse-intent-device-flow')) {
            if (flowType && flowType.toUpperCase() === 'POSTPAID_DEVICE') {
                var skuIdFromUrl = selectedDevice && Utilities.isIntentSet() ? selectedDevice.sku :
                    Utilities.getUrlParamValue('sku', baseURL && baseURL.url);
                var selectedDeviceConfigStr = window.sessionStorage.getItem('selectedDeviceConfig');
                if (selectedDeviceConfigStr) {
                    var selectedDeviceConfigFromPLP = JSON.parse(selectedDeviceConfigStr);
                    if (!Utilities.isEmpty(skuIdFromUrl)
                        && !Utilities.isEmptyObject(selectedDeviceConfigFromPLP)
                        && Utilities.isKeyExist(selectedDeviceConfigFromPLP, 'sku')
                        && !Utilities.isEmptyObject(selectedDeviceConfigFromPLP.sku)) {
                        flag = true;
                        stateManager.set(WirelessConstants_1.WirelessConstants.WIRELESS_SELECTED_DEVICE_SKU, { sku: skuIdFromUrl });
                    }
                }
            }
            else if (flowType && flowType.toUpperCase() === 'BYOD') {
                var deviceTypeFromUrl = Utilities.getUrlParamValue('devicetype', baseURL.url);
                var simTypeFromUrl = Utilities.getUrlParamValue('simtype', baseURL.url);
                if (deviceTypeFromUrl && simTypeFromUrl) {
                    flag = true;
                }
            }
        }
        return flag;
    };
    Utilities.generatePDPA2CRequest = function (selectedDeviceConfig) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var postData = null;
        var wirelessType = Utilities.getWirelessType();
        var commitmentTerm = !Utilities.isEmpty(selectedDeviceConfig.commitmentTerm) &&
            selectedDeviceConfig.commitmentTerm.toUpperCase();
        var commitmentTermName = ((commitmentTerm === 'NOCOMMITMENT') ? '1' : (commitmentTerm === '2YEAR') ? '24' : commitmentTerm);
        var commitmentTermNameprepaid = commitmentTermName;
        if ("PREPAID" /* PREPAID */ === wirelessType && commitmentTermNameprepaid === '1') {
            commitmentTermNameprepaid = '0';
        }
        var selectedSku = selectedDeviceConfig.sku.priceList.find(function (priceList) {
            return !Utilities.isEmpty(priceList.name) && (priceList.name.toUpperCase() === commitmentTermName ||
                priceList.name.toUpperCase() === commitmentTermNameprepaid);
        });
        if (selectedSku) {
            var hylaTradeInIntentIndicator = false;
            var portInIntentIndicator = false;
            // set trade in and port in indicators from PDP
            this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
            if (selectedDeviceConfig.hylaTradeInIntentIndicator) {
                this.stateManager.set(WirelessConstants_1.WirelessConstants.WIRELESS_TRADEIN_INTENT_PDP, { intent: true });
                hylaTradeInIntentIndicator = true;
            }
            if (selectedDeviceConfig.portinIndicator) {
                this.stateManager.set(WirelessConstants_1.WirelessConstants.WIRELESS_PORTIN_INTENT_PDP, { intent: true });
                portInIntentIndicator = true;
            }
            var contractLength = '';
            var contractType = 'onetime';
            var skuType = !Utilities.isEmpty(selectedSku.type) && selectedSku.type.toUpperCase();
            if (skuType === 'LEASE' || skuType === 'INSTALL') {
                contractLength = selectedSku.leaseTotalMonths.toString();
                contractType = 'monthly';
            }
            else if (skuType === 'REGULAR') {
                contractLength = selectedSku.name;
            }
            // BYOD:AL- extraData is sent through selectedDeviceConfig cookie
            var extraData = void 0;
            if (selectedDeviceConfig && selectedDeviceConfig.extraData && selectedDeviceConfig.extraData.deviceTypeForByod) {
                extraData = selectedDeviceConfig.extraData;
            }
            var offerCode = hylaTradeInIntentIndicator ?
                {
                    offerCode: (_a = selectedDeviceConfig.shoppingContext) === null || _a === void 0 ? void 0 : _a.offerCode,
                } : {};
            postData = {
                hylaTradeInIntentIndicator: hylaTradeInIntentIndicator,
                itemsList: [
                    {
                        action: CartActions_1.ActionType.ADD,
                        commitmentTerm: commitmentTerm,
                        commitmentTermId: '',
                        continueCurrentCart: false,
                        contractLength: contractLength,
                        contractType: contractType,
                        extraData: extraData,
                        itemType: CartActions_1.ItemType.DEVICE,
                        losgId: '',
                        losgType: Utilities.getLosgType(null),
                        offerId: selectedDeviceConfig.sku.productId,
                        productGroup: CartActions_1.ProductGroupType.WIRELESS,
                        productSKU: selectedDeviceConfig.sku.skuId,
                        quantity: 1,
                    },
                ],
                portInIntentIndicator: portInIntentIndicator,
                serviceContext: {
                    srcSystem: CartActions_1.SrcSystem.IDSE,
                },
                shoppingContext: __assign(__assign(__assign(__assign(__assign({}, (Utilities.isIxpFeatureEnabled('svc-enable-hyla-details-downstream') ?
                    {
                        hylaImageUrl: (_b = selectedDeviceConfig === null || selectedDeviceConfig === void 0 ? void 0 : selectedDeviceConfig.hylaTradeInResponse) === null || _b === void 0 ? void 0 : _b.image,
                        make: (_c = selectedDeviceConfig === null || selectedDeviceConfig === void 0 ? void 0 : selectedDeviceConfig.hylaTradeInResponse) === null || _c === void 0 ? void 0 : _c.make,
                        model: (_d = selectedDeviceConfig === null || selectedDeviceConfig === void 0 ? void 0 : selectedDeviceConfig.hylaTradeInResponse) === null || _d === void 0 ? void 0 : _d.productFamily,
                    } : {})), (Utilities.isIxpFeatureEnabled('svc-hyla-tradein') ? {
                    hylaTradeInInfo: {
                        modelPrice: (_e = selectedDeviceConfig === null || selectedDeviceConfig === void 0 ? void 0 : selectedDeviceConfig.hylaTradeInResponse) === null || _e === void 0 ? void 0 : _e.hylaDiscountAmount,
                        modelCode: (_f = selectedDeviceConfig === null || selectedDeviceConfig === void 0 ? void 0 : selectedDeviceConfig.hylaTradeInResponse) === null || _f === void 0 ? void 0 : _f.modelCode,
                        capacity: (_g = selectedDeviceConfig === null || selectedDeviceConfig === void 0 ? void 0 : selectedDeviceConfig.hylaTradeInResponse) === null || _g === void 0 ? void 0 : _g.capacity,
                        questions: (_h = selectedDeviceConfig === null || selectedDeviceConfig === void 0 ? void 0 : selectedDeviceConfig.hylaTradeInResponse) === null || _h === void 0 ? void 0 : _h.questionAnswers,
                        tradeInDeviceCondition: (_j = selectedDeviceConfig === null || selectedDeviceConfig === void 0 ? void 0 : selectedDeviceConfig.hylaTradeInResponse) === null || _j === void 0 ? void 0 : _j.tradeInDeviceCondition,
                    }
                } : {})), { hylatradeInIntentRejected: !hylaTradeInIntentIndicator }), offerCode), { paymentType: this.getWirelessType() === "PREPAID" /* PREPAID */ ? "PREPAID" /* PREPAID */ : '' }),
            };
        }
        return postData;
    };
    Utilities.isMixedCart = function () {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var isMixedCart = false;
        var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        if (Utilities.isUpgradeFlow() && Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs') &&
            !Utilities.isEmptyObject(cartResponse.content.payload.wirelessCart.losgs)) {
            Object.values(cartResponse.content.payload.wirelessCart.losgs).forEach(function (losg) {
                if (losg.losgType === 'AL') {
                    isMixedCart = true;
                }
            });
        }
        return isMixedCart;
    };
    Utilities.isAALSinglePlanData = function () {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var authDetails = stateManager.get(WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE, WirelessConstants_1.WirelessConstants.APPSHELL_WIRELESS_AUTH_DETAILS);
        if (authDetails && authDetails.eligibleForNewPlan === false && authDetails.showJoinGroup === false) {
            return true;
        }
        return false;
    };
    Utilities.isShowJoinGroupEnabled = function () {
        var _a;
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var authDetails = stateManager.get(WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE, WirelessConstants_1.WirelessConstants.APPSHELL_WIRELESS_AUTH_DETAILS);
        return (_a = authDetails === null || authDetails === void 0 ? void 0 : authDetails.showJoinGroup) !== null && _a !== void 0 ? _a : false;
    };
    Utilities.isAALSinglePlanDataMnM = function (losgType) {
        if (Utilities.isAALFlow() || (Utilities.isMixedCart() && losgType && losgType === CartActions_2.LosgType.AL)) {
            var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
            var authDetails = stateManager.get(WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE, WirelessConstants_1.WirelessConstants.APPSHELL_WIRELESS_AUTH_DETAILS);
            if (authDetails && authDetails.showJoinGroup === false && authDetails.planItemBean
                && (!(authDetails.accountDetails && authDetails.accountDetails.planGroups &&
                    authDetails.accountDetails.planGroups.length > 0))
                && (authDetails.planItemBean.isMnM || authDetails.planItemBean.isLLP)) {
                return true;
            }
            return false;
        }
        return false;
    };
    Utilities.formatPhoneNumberWithDot = function (value) {
        var phoneRegex = new RegExp('^[0-9.]*$');
        var tempNumber;
        if (value && value.length > 0 && phoneRegex.test(value)) {
            tempNumber = value.replace(/[^0-9]/g, '');
        }
        else {
            return value;
        }
        if (tempNumber && tempNumber.length > 3 && tempNumber.length < 7) {
            return tempNumber.replace(/(\d{3})(\d*)/, '$1' + '.' + '$2');
        }
        else if (tempNumber && tempNumber.length > 6 && tempNumber.length < 11) {
            return tempNumber.replace(/(\d{3})(\d{3})(\d*)/, '$1' + '.' + '$2' + '.' + '$3');
        }
        else {
            return value;
        }
    };
    Utilities.removeSpecialChars = function (value) {
        if (value) {
            return value.replace(/[^a-zA-Z0-9]/g, '');
        }
        else {
            return value;
        }
    };
    Utilities.retrieveIntent = function () {
        var wlsIntent = StateProvider_1.StateProvider.getStateManagerInstance().get(WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE, WirelessConstants_1.WirelessConstants.APPSHELL_WIRELESS_INTENT);
        return (wlsIntent && wlsIntent.wirelessIntent) ? wlsIntent.wirelessIntent : '';
    };
    Utilities.retrieveEAPDeviceLineItem = function (losg) {
        if (this.isEmptyObject(losg) || this.isEmptyObject(losg.lineItems)) {
            return null;
        }
        if (!Utilities.isEmpty(losg.losgType) && (losg.losgType.toUpperCase() === ('AL') ||
            losg.losgType.toUpperCase() === ('NEW')) && losg._extraParams &&
            this.isKeyExist(losg._extraParams, 'activation') && losg._extraParams.activation) {
            return Object.values(losg.lineItems)
                .find(function (item) { return !Utilities.isEmpty(item._itemType) ? item._itemType.toUpperCase() === 'DEVICE' : false; });
        }
    };
    // method to check whether flow is EAP or not
    Utilities.isEAPFlow = function (sendLosg, cartResponse) {
        var _this = this;
        var isEAPFLow;
        var eapLosg = null;
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        if (Utilities.isEmptyObject(cartResponse)) {
            cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        }
        var wirelessCart = Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart') &&
            cartResponse.content.payload.wirelessCart;
        if (wirelessCart && ((!wirelessCart._paymentType && Utilities.getWirelessType() === "POSTPAID" /* POSTPAID */)
            || (wirelessCart._paymentType && Utilities.getWirelessType() === "PREPAID" /* PREPAID */)) &&
            this.isKeyExist(wirelessCart, 'losgs') && !Utilities.isEmptyObject(wirelessCart.losgs)) {
            var losgs_9 = wirelessCart.losgs;
            Object.keys(losgs_9).forEach(function (losgKey) {
                var losg = losgs_9[losgKey];
                if (!Utilities.isEmpty(losg.losgType) && (losg.losgType.toUpperCase() === ('AL') ||
                    losg.losgType.toUpperCase() === ('NEW')) && losg._extraParams &&
                    _this.isKeyExist(losg._extraParams, 'activation') && losg._extraParams.activation) {
                    isEAPFLow = true;
                }
                else {
                    isEAPFLow = false;
                }
                if (_this.isKeyExist(losg, 'lineItems') && !_this.isEmptyObject(losg.lineItems)) {
                    var lineItems_5 = losg.lineItems;
                    Object.keys(lineItems_5).forEach(function (lineItemKey) {
                        if (!Utilities.isEmpty(lineItems_5[lineItemKey]._itemType)) {
                            var iType = lineItems_5[lineItemKey]._itemType.toUpperCase();
                            if (iType === CartActions_1.ItemType.DEVICE.toUpperCase()) {
                                eapLosg = losg;
                            }
                        }
                    });
                }
            });
        }
        if (sendLosg) {
            return eapLosg;
        }
        return eapLosg ? isEAPFLow : false;
    };
    Utilities.getProductType = function (productTypeInput) {
        var productType;
        var isbyod = Utilities.isBYODFlow();
        var isbyodOnly = Utilities.isBYODFlow(false, null, true);
        var isDeviceExist = Utilities.isBYODFlow(false, null, false, true);
        if ((Utilities.getWirelessType() === 'POSTPAID') && (Utilities.isEAPBMWFlow())) {
            productType = Utilities.getProductTypeWithBYOD('EAP Postpaid Connected Car', isbyod, isbyodOnly, productTypeInput, isDeviceExist);
        }
        else if (Utilities.getWirelessType() === 'POSTPAID') {
            productType = Utilities.getProductTypeWithBYOD('Postpaid', isbyod, isbyodOnly, productTypeInput, isDeviceExist);
        }
        else {
            productType = Utilities.getProductTypeWithBYOD('Prepaid', isbyod, isbyodOnly, productTypeInput, isDeviceExist);
        }
        return productType;
    };
    Utilities.getEnvironmentDomain = function () {
        var currentDomain = window.location.hostname;
        var attDomains = ['.dev.att.com', '.stage.att.com', '.test-e.att.com'];
        var domain = '';
        attDomains.forEach(function (attDomain) {
            if (currentDomain.includes(attDomain)) {
                domain = 'https://www.att.com';
            }
        });
        return domain;
    };
    Utilities.getProductTypeWithBYOD = function (productType, isbyod, isbyodOnly, productTypeInput, isDeviceExist) {
        if (productTypeInput === WirelessConstants_1.WirelessConstants.WIRELESS_EAP_PRODUCT_TYPE || Utilities.isEapSet()) {
            return WirelessConstants_1.WirelessConstants.WIRELESS_EAP_PRODUCT_TYPE;
        }
        else if (Utilities.getWirelessSubFlow() === "ONDEVICE" /* ON_DEVICE */) {
            return WirelessConstants_1.WirelessConstants.WIRELESS_EAP_ON_DEVICE_PRODUCT_TYPE;
        }
        else if ((isbyod && !isbyodOnly) || (productTypeInput && 'BYOD' === productTypeInput && isDeviceExist)) {
            return productType + '|' + productType + ' BYOD';
        }
        else if (isbyod || (productTypeInput && 'BYOD' === productTypeInput)) {
            return productType + ' BYOD';
        }
        else {
            return productType;
        }
    };
    Utilities.getClientDeviceType = function () {
        if (window) {
            if (window.innerWidth > 1024) {
                return 'D';
            }
            else if (window.innerWidth < 425) {
                return 'M';
            }
            else {
                return 'T';
            }
        }
        return '';
    };
    Utilities.interpolatePlaceholders = function (textWithPlaceholder, content) {
        if (textWithPlaceholder !== undefined && content.length > 0) {
            content.map(function (value, index) {
                textWithPlaceholder = textWithPlaceholder.replace('{' + index + '}', value);
            });
            return textWithPlaceholder;
        }
    };
    Utilities.reloadOnEmptywirelessCart = function () {
        if (Utilities.isUpgradeFlow()) {
            window.location.href = '/buy/wireless/?wlsfi=up';
        }
        else if (Utilities.isAALFlow()) {
            window.location.href = '/buy/wireless/?wlsfi=al';
        }
        else {
            window.location.reload();
        }
    };
    Utilities.hasPlanDetailsUrl = function () {
        return window.location.href.indexOf('plandetails') >= 0 ? true : false;
    };
    Utilities.isBYODSimInCart = function (cartResponse) {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var cartResponseKey = cartResponse ? cartResponse :
            stateManager.getForProxy(WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        var wirelessCart = Utilities.isKeyExist(cartResponseKey, 'content.payload.wirelessCart') &&
            cartResponseKey.content.payload.wirelessCart;
        var byodSim = false;
        var losgs = Utilities.isKeyExist(wirelessCart, 'losgs') && Object.values(wirelessCart.losgs);
        for (var _i = 0, losgs_10 = losgs; _i < losgs_10.length; _i++) {
            var losg = losgs_10[_i];
            var lineWithByodSim = Object.values(losg.lineItems)
                .find(function (line) { return ((line && line.itemType && line.itemType.toUpperCase() === 'HARDGOOD') ||
                (line && line.itemType && line.itemType.toLowerCase() === 'DEVICE')) &&
                (line.hardGood && line.hardGood.hardGoodType
                    && (line.hardGood.hardGoodType.toUpperCase() === 'SIM') || (line.hardGood.hardGoodType.toUpperCase() === 'DEVICE')); });
            if (lineWithByodSim) {
                byodSim = true;
            }
        }
        return byodSim;
    };
    Utilities.activationDeviceSku = function () {
        var _this = this;
        var activationDeviceSku = null;
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        if (this.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs') &&
            !Utilities.isEmptyObject(cartResponse.content.payload.wirelessCart.losgs)) {
            var losgs_11 = cartResponse.content.payload.wirelessCart.losgs;
            Object.keys(losgs_11).forEach(function (losgKey) {
                var losg = losgs_11[losgKey];
                if (!Utilities.isEmpty(losg.losgType) && (losg.losgType.toUpperCase() === ('AL') ||
                    losg.losgType.toUpperCase() === ('NEW')) && losg._extraParams &&
                    _this.isKeyExist(losg._extraParams, 'activation') && losg._extraParams.activation) {
                    if (_this.isKeyExist(losg, 'lineItems') && !_this.isEmptyObject(losg.lineItems)) {
                        var lineItems_6 = losg.lineItems;
                        Object.keys(lineItems_6).forEach(function (lineItemKey) {
                            if (!Utilities.isEmpty(lineItems_6[lineItemKey]._itemType)) {
                                var iType = lineItems_6[lineItemKey]._itemType.toUpperCase();
                                if (iType === CartActions_1.ItemType.DEVICE.toUpperCase()) {
                                    activationDeviceSku = lineItems_6[lineItemKey].productSKU;
                                }
                            }
                        });
                    }
                }
            });
        }
        return activationDeviceSku;
    };
    Utilities.MNMRLLPplanInCart = function (lineItem, planTypeRef) {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        var plan;
        if (Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs') && !lineItem) {
            plan = Utilities.getLineItemFromCart(cartResponse.content.payload.wirelessCart.losgs, CartActions_1.ItemType.SHARED_DATA_GROUP.toString());
        }
        else if (lineItem) {
            plan = lineItem;
        }
        if (planTypeRef && planTypeRef === 'MNM') {
            return (plan && plan._itemExtraAttributes) ? (plan._itemExtraAttributes.isMnM === 'true') : false;
        }
        else {
            return (plan && plan._itemExtraAttributes) ?
                (plan._itemExtraAttributes.isLLP === 'true' || plan._itemExtraAttributes.isMnM === 'true') : false;
        }
    };
    // This function is to check WLS_DEVICE_CELLPHONE in cartresponse to show/hide the alert message
    // when only wearable/tablet is added to cart without a cell phone.
    Utilities.noCellPhoneInCart = function () {
        var showWearableInfoMessage = false;
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        if (!Utilities.isEmptyObject(cartResponse) &&
            Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs') &&
            !Utilities.isEmptyObject(cartResponse.content.payload.wirelessCart.losgs) &&
            Utilities.isDeviceInCart()) {
            Object.values(cartResponse.content.payload.wirelessCart.losgs).forEach(function (value) {
                if (value && value.requiredToCheckout &&
                    value.requiredToCheckout.includes(CartActions_1.requiredToCheckoutType.WLS_DEVICE_CELLPHONE)) {
                    showWearableInfoMessage = true;
                }
            });
        }
        return showWearableInfoMessage;
    };
    Utilities.getPlanInCart = function (planTypeRef) {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        var plan;
        if (Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs')) {
            plan = Utilities.getLineItemFromCart(cartResponse.content.payload.wirelessCart.losgs, CartActions_1.ItemType.SHARED_DATA_GROUP.toString());
        }
        if (planTypeRef === 'MNM') {
            return (plan && plan._itemExtraAttributes) && plan._itemExtraAttributes.isMnM === 'true' ? plan : null;
        }
        else if (planTypeRef === 'LLP') {
            return (plan && plan._itemExtraAttributes) && plan._itemExtraAttributes.isLLP === 'true' ? plan : null;
        }
    };
    Utilities.isplanInCart = function (planTypeRef, cartResponse) {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var plan;
        var dataPlan;
        if (Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs')) {
            plan = Utilities.getLineItemFromCart(cartResponse.content.payload.wirelessCart.losgs, CartActions_1.ItemType.SHARED_DATA_GROUP.toString());
            dataPlan = Utilities.getLineItemFromCart(cartResponse.content.payload.wirelessCart.losgs, CartActions_1.ItemType.DATAPLAN.toString());
        }
        var planincart = false;
        if (plan && plan._itemExtraAttributes) {
            if (planTypeRef === 'MNM') {
                planincart = plan._itemExtraAttributes.isMnM === 'true' ? true : false;
            }
            else if (planTypeRef === 'LLP') {
                planincart = plan._itemExtraAttributes.isLLP === 'true' ? true : false;
            }
        }
        if (planTypeRef === 'DATA_PLAN' && dataPlan) {
            planincart = true;
        }
        return planincart;
    };
    Utilities.setCustomerTypeParamsForGlobalNav = function (customerType) {
        var globalNav = document.querySelector('attwc-globalnav-header');
        if (globalNav && globalNav.customerType) {
            globalNav.customerType = customerType;
            globalNav.excludeCoreElements = 'search';
        }
        globalNav = document.querySelector('attwc-globalnav-footer');
        if (globalNav && globalNav.customerType) {
            globalNav.customerType = customerType;
        }
    };
    // This function evaluates show/hide plan carousel for M&M and LLP Plans.
    // If no device in cart, hide plan carousel for both M&M and LLP.
    // For LLP if plan is already selected, the plan carousel will be hidden for more than 1 device.
    // For M&M if both plan & device is in cart hide the plan carousel and if only device
    // is in cart shpw the plan carosuel.
    Utilities.showHidePlanPanelForMNMLLP = function () {
        var showPlanPanel = true;
        if (Utilities.getWirelessType() === "POSTPAID" /* POSTPAID */ &&
            Utilities.isIxpFeatureEnabled('svc-idp-wireless-enable-mix-n-match-plans')) {
            var deviceInCart = Utilities.isDeviceInCart();
            if (!deviceInCart) {
                showPlanPanel = false;
            }
            else {
                var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
                var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
                //  const isPlanInCart: boolean = Utilities.MNMRLLPplanInCart();
                var llpflag = Utilities.isplanInCart('LLP', cartResponse);
                var mnmflag = Utilities.isplanInCart('MNM', cartResponse);
                var dataPlanflag = Utilities.isplanInCart('DATA_PLAN', cartResponse);
                // if (llpflag) {
                //   showPlanPanel = false;
                // } else
                if (mnmflag || llpflag) {
                    var bothPlanDeviceExists = Utilities.bothDeviceAndPlanInAlllosg(cartResponse.content.payload.wirelessCart.losgs);
                    showPlanPanel = !bothPlanDeviceExists;
                }
                else if (dataPlanflag) {
                    var bothDataPlanDeviceExists = Utilities.bothDeviceAndDataPlanInAlllosg(cartResponse.content.payload.wirelessCart.losgs);
                    showPlanPanel = !bothDataPlanDeviceExists;
                }
            }
        }
        return showPlanPanel;
    };
    Utilities.recentlyAddedLosg = function () {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        var mostRecentlyAdded;
        if (Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs')) {
            var losgsInCart = Object.values(cartResponse.content.payload.wirelessCart.losgs);
            losgsInCart = Object.values(losgsInCart)
                .sort(function (losgA, losgB) { return losgA.sequence - losgB.sequence; }).reverse();
            losgsInCart = losgsInCart.filter(function (losg) { return (!Utilities.isIgnoreLOSG(losg.losgType)); });
            while (!Utilities.isEmptyObject(losgsInCart)) {
                mostRecentlyAdded = losgsInCart.pop();
            }
        }
        return mostRecentlyAdded;
    };
    Utilities.getFirstAddedLosgFromCart = function () {
        var cartResponse = Utilities.getCartResponse();
        var firstAddedLosg;
        if (Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs')) {
            var losgsInCart = Object.values(cartResponse.content.payload.wirelessCart.losgs);
            losgsInCart = Object.values(losgsInCart)
                .sort(function (losgA, losgB) { return losgA.sequence - losgB.sequence; });
            losgsInCart = losgsInCart.filter(function (losg) { return (!Utilities.isIgnoreLOSG(losg.losgType)); });
            if (losgsInCart && losgsInCart.length > 0) {
                firstAddedLosg = losgsInCart[0];
            }
        }
        return firstAddedLosg;
    };
    Utilities.checkDeviceAndPlanInLosg = function () {
        var _this = this;
        var itemTypeDataFeature = CartActions_1.ItemType.SHARED_DATA_FEATURE;
        var itemTypeDataPlan = CartActions_1.ItemType.DATA_PLAN;
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var recentlyAddedLosg = null;
        var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        if (Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs')) {
            var losgs_12 = cartResponse.content.payload.wirelessCart.losgs;
            if (!Utilities.isEmptyObject(losgs_12)) {
                Object.keys(losgs_12).forEach(function (losgKey) {
                    var losg = losgs_12[losgKey];
                    if (_this.isKeyExist(losg, 'lineItems') && !_this.isEmptyObject(losg.lineItems)) {
                        var lineItems_7 = losg.lineItems;
                        var planExists = Object.keys(lineItems_7).find(function (lineItemKey) {
                            return (lineItems_7[lineItemKey]._itemType.toUpperCase() === itemTypeDataFeature ||
                                lineItems_7[lineItemKey]._itemType.toUpperCase() === itemTypeDataPlan);
                        });
                        if (_this.isEmpty(planExists)) {
                            recentlyAddedLosg = losg;
                        }
                    }
                });
            }
        }
        return recentlyAddedLosg;
    };
    // To check if all the losgs in cart has both plan and device.
    Utilities.bothDeviceAndPlanInAlllosg = function (losgs) {
        var _this = this;
        var bothPlanDeviceExists = true;
        if (bothPlanDeviceExists && !Utilities.isEmptyObject(losgs)) {
            Object.keys(losgs).forEach(function (losgKey) {
                var losg = losgs[losgKey];
                if (_this.isKeyExist(losg, 'lineItems') &&
                    !_this.isEmptyObject(losg.lineItems)) {
                    var lineItems_8 = losg.lineItems;
                    var planExist = false;
                    var deviceExist_1 = false;
                    var sdgExist_1 = false;
                    var sdfExist_1 = false;
                    Object.keys(lineItems_8).forEach(function (lineItemKey) {
                        if (lineItems_8[lineItemKey] && !Utilities.isEmpty(lineItems_8[lineItemKey]._itemType) &&
                            (!sdgExist_1 || !sdfExist_1 || !deviceExist_1)) {
                            var iType = lineItems_8[lineItemKey]._itemType.toUpperCase();
                            if (!sdgExist_1 &&
                                iType === CartActions_1.ItemType.SHARED_DATA_GROUP.toString().toUpperCase()) {
                                sdgExist_1 = true;
                            }
                            if (!sdfExist_1 &&
                                iType === CartActions_1.ItemType.SHARED_DATA_FEATURE.toString().toUpperCase()) {
                                sdfExist_1 = true;
                            }
                            if (!deviceExist_1 &&
                                iType === CartActions_1.ItemType.DEVICE.toString().toUpperCase()) {
                                deviceExist_1 = true;
                            }
                        }
                    });
                    planExist = sdgExist_1 && sdfExist_1 ? true : false;
                    if (deviceExist_1 && !planExist) {
                        bothPlanDeviceExists = false;
                    }
                }
            });
        }
        return bothPlanDeviceExists;
    };
    Utilities.noPhoneDeviceInCart = function () {
        var noOfPhoneDevices = 0;
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        if (Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs')) {
            var losgs = cartResponse.content.payload.wirelessCart.losgs;
            for (var losg in losgs) {
                if (losgs.hasOwnProperty(losg)) {
                    var getDeviceLineItem = Utilities.getLosgItemFromCart(losg, CartActions_1.ItemType.DEVICE.toString());
                    if (Utilities.isKeyExist(getDeviceLineItem, '_itemExtraAttributes.device_group_name')
                        && typeof getDeviceLineItem._itemExtraAttributes.device_group_name === 'string'
                        && getDeviceLineItem._itemExtraAttributes.device_group_name.toUpperCase() === 'CELLPHONE') {
                        noOfPhoneDevices += 1;
                    }
                }
            }
        }
        return noOfPhoneDevices;
    };
    Utilities.bothDeviceAndDataPlanInAlllosg = function (losgs) {
        var _this = this;
        var bothPlanDeviceExists = true;
        if (bothPlanDeviceExists && !Utilities.isEmptyObject(losgs)) {
            Object.keys(losgs).forEach(function (losgKey) {
                var losg = losgs[losgKey];
                if (_this.isKeyExist(losg, 'lineItems') &&
                    !_this.isEmptyObject(losg.lineItems)) {
                    var lineItems_9 = losg.lineItems;
                    var planExist_1 = false;
                    var deviceExist_2 = false;
                    Object.keys(lineItems_9).forEach(function (lineItemKey) {
                        if (lineItems_9[lineItemKey] && !Utilities.isEmpty(lineItems_9[lineItemKey]._itemType) &&
                            (!planExist_1 || !deviceExist_2)) {
                            var iType = lineItems_9[lineItemKey]._itemType.toUpperCase();
                            if (!planExist_1 &&
                                iType === CartActions_1.ItemType.DATAPLAN.toString().toUpperCase()) {
                                planExist_1 = true;
                            }
                            if (!deviceExist_2 &&
                                iType === CartActions_1.ItemType.DEVICE.toString().toUpperCase()) {
                                deviceExist_2 = true;
                            }
                        }
                    });
                    if (!planExist_1 || !deviceExist_2) {
                        bothPlanDeviceExists = false;
                    }
                }
            });
        }
        return bothPlanDeviceExists;
    };
    Utilities.suppressFilterDeviceType = function () {
        var deviceTypeSelection = false;
        if (Utilities.getWirelessType() === "POSTPAID" /* POSTPAID */ && Utilities.isAALFlow() &&
            !Utilities.isIxpFeatureEnabled('svc-pcv1-mds-llp-data-plan')) {
            var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
            var wlsAuthDetails = stateManager.get(WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE, WirelessConstants_1.WirelessConstants.APPSHELL_WIRELESS_AUTH_DETAILS);
            if (!wlsAuthDetails.showJoinGroup && Utilities.isKeyExist(wlsAuthDetails, 'planItemBean.mnmCounter')
                && wlsAuthDetails.planItemBean.mnmCounter === 0 && (wlsAuthDetails.planItemBean.isMnM ||
                wlsAuthDetails.planItemBean.isLLP)) {
                var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
                deviceTypeSelection = true;
                if (Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs')) {
                    var losgs = cartResponse.content.payload.wirelessCart.losgs;
                    for (var losg in losgs) {
                        if (losgs.hasOwnProperty(losg)) {
                            var getDeviceLineItem = Utilities.getLosgItemFromCart(losg, CartActions_1.ItemType.DEVICE.toString());
                            if (Utilities.isKeyExist(getDeviceLineItem, '_itemExtraAttributes.device_group_name')
                                && typeof getDeviceLineItem._itemExtraAttributes.device_group_name === 'string'
                                && getDeviceLineItem._itemExtraAttributes.device_group_name.toUpperCase() === 'CELLPHONE') {
                                deviceTypeSelection = false;
                                break;
                            }
                        }
                    }
                }
            }
        }
        return deviceTypeSelection;
    };
    // get smb user
    Utilities.isSMBCRUUser = function () {
        var userSessionInfo = JSON.parse(sessionStorage.getItem('customerInfoSDK'));
        var isSMBCustomer = userSessionInfo !== null && userSessionInfo['user.account.liabilityType'] &&
            userSessionInfo['user.account.liabilityType'] === 'CRU' && userSessionInfo['user.account.accountInFocusUserType']
            && userSessionInfo['user.account.accountInFocusUserType'] === 'SMB' ? true : false;
        return isSMBCustomer;
    };
    Utilities.isPrimaryLineMNM = function (losg) {
        return losg._extraParams &&
            this.isKeyExist(losg._extraParams, 'primaryIndicatorMNM') && losg._extraParams.primaryIndicatorMNM &&
            losg._extraParams.primaryIndicatorMNM === 'true' ? true : false;
    };
    Utilities.getCustomerType = function () {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var wlsAuthDetails = stateManager.get(WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE, WirelessConstants_1.WirelessConstants.APPSHELL_WIRELESS_AUTH_DETAILS);
        var commonReturnCustomerType = "CONSUMER" /* CONSUMER */;
        if (Utilities.isKeyExist(wlsAuthDetails, 'profileDetails.customerType')
            && wlsAuthDetails.profileDetails.customerType) {
            switch (wlsAuthDetails.profileDetails.customerType) {
                case "IRU" /* IRU */:
                    return "IRU" /* IRU */;
                case "CRU" /* CRU */:
                    return "CRU" /* CRU */;
                default:
                    return commonReturnCustomerType;
            }
        }
        else {
            if (Utilities.getCookie('DTAB')) {
                return "CRU" /* CRU */;
            }
            else {
                return commonReturnCustomerType;
            }
        }
    };
    Utilities.getFlowType = function () {
        if (Utilities.isAALFlow()) {
            return 'AL';
        }
        else if (Utilities.isUpgradeFlow()) {
            return 'UP';
        }
        else {
            return '';
        }
    };
    Utilities.getUserFeatureFlag = function () {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var wlsAuthDetails = stateManager.get(WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE, WirelessConstants_1.WirelessConstants.APPSHELL_WIRELESS_AUTH_DETAILS);
        if (Utilities.isKeyExist(wlsAuthDetails, 'planItemBean.isMnM') || Utilities.isKeyExist(wlsAuthDetails, 'planItemBean.isLLP')) {
            if (wlsAuthDetails.planItemBean.isMnM) {
                return 'Mix And Match';
            }
            else if (wlsAuthDetails.planItemBean.isLLP) {
                return 'Line Level Pricing';
            }
            else {
                return null;
            }
        }
        return null;
    };
    Utilities.deviceInCartForInsurance = function () {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        var deviceIncart = false;
        var thirdParty = false;
        var isInsuranceInCart = false;
        var deviceDetailResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_DEVICE_DETAIL_RESPONSE_KEY);
        if (Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs')) {
            var planOnly = Object.values(cartResponse.content.payload.wirelessCart.losgs);
            var _loop_1 = function (losgs) {
                var foundDevice = losgs.lineItems && Object.values(losgs.lineItems).find(function (lines) {
                    return lines.itemType === 'device';
                });
                if (foundDevice && foundDevice._isThirdParty) {
                    if (Utilities.isKeyExist(deviceDetailResponse, 'features') &&
                        !Utilities.isEmptyObject(deviceDetailResponse.features)) {
                        thirdParty = true;
                        var insuranceMap = new Map(stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_VENDOR_INSURANCE));
                        var incompatible_1 = insuranceMap.get(losgs.id);
                        var insuranceProd = Object.values(deviceDetailResponse.features);
                        if (incompatible_1 && !Utilities.isEmptyObject(insuranceProd)) { // need a solution for session expiration
                            insuranceProd.forEach(function (prod) {
                                if (prod && !incompatible_1.includes(prod.offerId)) {
                                    deviceIncart = true;
                                }
                            });
                        }
                        // handle scenario in case of coming back after session and insurance already added
                        var keys_1 = Object.keys(deviceDetailResponse.features);
                        var foundInsurance = void 0;
                        if (keys_1 && !deviceIncart) {
                            foundInsurance = Object.values(losgs.lineItems).find(function (lines) {
                                return lines && lines.itemType === 'feature' && keys_1.includes(lines.offerId);
                            });
                            if (foundInsurance && !isInsuranceInCart) {
                                var deviceInfo = Object.values(losgs.lineItems).find(function (lines) {
                                    return lines.itemType === 'device';
                                });
                                if (deviceInfo) {
                                    isInsuranceInCart = true;
                                    deviceIncart = true;
                                }
                            }
                        }
                    }
                    if (deviceIncart) { // if eligible for one of the products. no need for complete suppression
                        return "break";
                    }
                }
                else {
                    if (foundDevice) {
                        deviceIncart = true;
                        return "break";
                    }
                }
            };
            for (var _i = 0, planOnly_2 = planOnly; _i < planOnly_2.length; _i++) {
                var losgs = planOnly_2[_i];
                var state_1 = _loop_1(losgs);
                if (state_1 === "break")
                    break;
            }
        }
        return deviceIncart;
    };
    Utilities.detectMobileBrowser = function () {
        var detectedBrowser = false;
        var ismobileBrowser = false;
        // viewportcheck
        var isMobileWidth = Math.min(window.screen.width, window.screen.height) < 768;
        if (navigator.userAgent.match(/Android/i)
            || navigator.userAgent.match(/webOS/i)
            || navigator.userAgent.match(/iPhone/i)
            || navigator.userAgent.match(/iPad/i)
            || navigator.userAgent.match(/iPod/i)
            || navigator.userAgent.match(/BlackBerry/i)
            || navigator.userAgent.match(/Opera Mini/i)
            || navigator.userAgent.match(/IEMobile/i)
            || navigator.userAgent.match(/Windows Phone/i)) {
            ismobileBrowser = true;
        }
        // checking both viewport as well as navigation
        if (isMobileWidth || ismobileBrowser) {
            detectedBrowser = true;
        }
        return detectedBrowser;
    };
    Utilities.derivePrimaryLOSGIdALFlow = function () {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        var primaryLosg;
        var foundPrimaryLosg = false;
        if (Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs')) {
            var losgs = Object.values(cartResponse.content.payload.wirelessCart.losgs).
                sort(function (losgA, losgB) { return losgA.sequence - losgB.sequence; });
            for (var _i = 0, losgs_13 = losgs; _i < losgs_13.length; _i++) {
                var losg = losgs_13[_i];
                var lineItems = losg.lineItems && Object.values(losg.lineItems);
                if (lineItems) {
                    for (var _a = 0, lineItems_10 = lineItems; _a < lineItems_10.length; _a++) {
                        var lineItem = lineItems_10[_a];
                        if (lineItem._itemType === 'device') {
                            if (Utilities.isKeyExist(lineItem, '_itemExtraAttributes.device_group_name')
                                && typeof lineItem._itemExtraAttributes.device_group_name === 'string'
                                && lineItem._itemExtraAttributes.device_group_name.toUpperCase() === 'CELLPHONE') {
                                primaryLosg = losg.id;
                                foundPrimaryLosg = true;
                                break;
                            }
                        }
                        if (foundPrimaryLosg) {
                            break;
                        }
                    }
                }
            }
        }
        return foundPrimaryLosg ? primaryLosg : null;
    };
    Utilities.inCartTradeInPromotion = function (losg) {
        // const planPromotions: CartPromotion[] = [];
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        var deviceLineitem = Utilities.getLosgItemFromCart(losg.id, CartActions_1.ItemType.DEVICE.toString());
        var cartPromotion;
        if (Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.promotions') &&
            !Utilities.isEmptyObject(cartResponse.content.payload.wirelessCart.promotions)) {
            cartResponse.content.payload.wirelessCart.promotions.forEach(function (promotion) {
                if (promotion && promotion.promotionType === 'DEVICE_TRADEIN' &&
                    (Utilities.hasHylaTradeInOffer(losg.id) ? true : false)) {
                    deviceLineitem.promotionReferences.forEach(function (promRef) {
                        if (promRef === promotion.id) {
                            cartPromotion = promotion;
                        }
                    });
                }
            });
        }
        return cartPromotion;
    };
    Utilities.hasPromoPrice = function (line) {
        var hasPromo = false;
        var deviceDetailResponse = StateProvider_1.StateProvider.getStateManagerInstance().get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_DEVICE_DETAIL_RESPONSE_KEY);
        if (deviceDetailResponse && deviceDetailResponse.devices) {
            var selectedDevice = Object.values(deviceDetailResponse.devices).find(function (device) {
                return device.product.childSkus.find(function (sku) { return sku.skuId === line.productSKU; });
            });
            if (selectedDevice && selectedDevice.product && selectedDevice.product.childSkus) {
                var selectedSku = selectedDevice.product.childSkus.find(function (sku) { return sku.skuId === line.productSKU; });
                if (selectedSku && selectedSku.price && selectedSku.price.length > 0) {
                    var priceObj = selectedSku.price.find(function (price) {
                        return price.type.toUpperCase() === 'MONTHLY' && price.monthlyNextUpCharge === 0;
                    });
                    if (priceObj && priceObj.promoPrice && priceObj.promoPrice > 0
                        && priceObj.promoPrice !== priceObj.netPrice) {
                        hasPromo = true;
                    }
                }
            }
        }
        return hasPromo;
    };
    Utilities.setlosgConsent = function (losgId, flagName, flagValue) {
        var _a;
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var losgConsent = (stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_LOSG_CONSENT) || {});
        losgConsent[losgId] = Object.assign({}, losgConsent[losgId], (_a = {}, _a[flagName] = flagValue, _a));
        stateManager.set(WirelessConstants_1.WirelessConstants.WIRELESS_LOSG_CONSENT, losgConsent);
    };
    Utilities.getlosgConsent = function (losgId, flagName) {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var losgConsent = (stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_LOSG_CONSENT) || {});
        return losgConsent && losgConsent[losgId] && losgConsent[losgId][flagName] ?
            losgConsent[losgId] && losgConsent[losgId][flagName] : null;
    };
    Utilities.isAccountPastDue = function () {
        var wlsAuthDetails = StateProvider_1.StateProvider.getStateManagerInstance().get(WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE, WirelessConstants_1.WirelessConstants.APPSHELL_WIRELESS_AUTH_DETAILS);
        if (Utilities.isKeyExist(wlsAuthDetails, 'accountDetails.pastDue') && Utilities.isKeyExist(wlsAuthDetails, 'accountDetails.pastDueInd')) {
            return wlsAuthDetails.accountDetails.pastDue > 35 && wlsAuthDetails.accountDetails.pastDueInd;
        }
        return false;
    };
    Utilities.getLineItemPrice = function (line) {
        var price = 0;
        var deviceDetailResponse = StateProvider_1.StateProvider.getStateManagerInstance().get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_DEVICE_DETAIL_RESPONSE_KEY);
        if (deviceDetailResponse && deviceDetailResponse.devices) {
            var selectedDevice = Object.values(deviceDetailResponse.devices).find(function (device) {
                return device.product.childSkus.find(function (sku) { return sku.skuId === line.productSKU; });
            });
            if (selectedDevice && selectedDevice.product && selectedDevice.product.childSkus) {
                var selectedSku = selectedDevice.product.childSkus.find(function (sku) { return sku.skuId === line.productSKU; });
                if (selectedSku && selectedSku.price && selectedSku.price.length > 0) {
                    var priceObj = selectedSku.price.find(function (price) {
                        return price.type.toUpperCase() === 'MONTHLY' && price.monthlyNextUpCharge === 0;
                    });
                    if (priceObj && priceObj.netPrice) {
                        price = priceObj.netPrice;
                    }
                }
            }
        }
        return price;
    };
    Utilities.hasHylaTradeInOffer = function (losgId) {
        var hasOffer = false;
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var hylaFromSM = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_HYLA_TRADEIN);
        var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        if (cartResponse && Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs')) {
            var tempLosg = cartResponse.content.payload.wirelessCart.losgs[losgId];
            if (tempLosg && Utilities.isKeyExist(tempLosg, '_extraParams.hylaTradeinAvailable')) {
                hasOffer = tempLosg._extraParams.hylaTradeinAvailable === 'true' ? true : false;
            }
        }
        if (!hasOffer) {
            hasOffer = !Utilities.isEmptyObject(hylaFromSM) && hylaFromSM.length > 0
                && hylaFromSM.find(function (offer) { return offer.losgId === losgId && offer.tradeIn && offer.tradeIn === true; }) ? true : false;
        }
        return hasOffer;
    };
    Utilities.hasPortInOffer = function (losgId) {
        var hasOffer = false;
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var hylaFromSM = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_HYLA_TRADEIN);
        var portinFromSM = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_PORTIN_ONLY);
        var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        if (cartResponse && Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs')) {
            var tempLosg = cartResponse.content.payload.wirelessCart.losgs[losgId];
            if (tempLosg && Utilities.isKeyExist(tempLosg, '_extraParams.portinPromotionAvailable')) {
                hasOffer = tempLosg._extraParams.portinPromotionAvailable === 'true' ? true : false;
            }
        }
        if (!hasOffer) {
            hasOffer = !Utilities.isEmptyObject(hylaFromSM) && hylaFromSM.length > 0
                && hylaFromSM.find(function (offer) { return offer.losgId === losgId && offer.isSwitcherPromo &&
                    offer.isSwitcherPromo === true; }) ? true : false;
        }
        if (!hasOffer) {
            if (!Utilities.isEmptyObject(portinFromSM)) {
                Object.values(portinFromSM).forEach(function (portinOffers) {
                    if (portinOffers.losgId === losgId && portinOffers.promoType === 'standalonePortIn') {
                        hasOffer = true;
                    }
                });
            }
        }
        return hasOffer;
    };
    // return if plan exist in losg
    Utilities.isPlanExistInLosg = function (losgId) {
        return this.getLosgItemFromCart(losgId, CartActions_1.ItemType.SHARED_DATA_FEATURE.toString())
            ? true :
            (this.getLosgItemFromCart(losgId, CartActions_1.ItemType.SHARED_DATA_GROUP.toString())
                ? true :
                (this.getLosgItemFromCart(losgId, CartActions_1.ItemType.DATA_PLAN.toString())
                    ? true :
                    (this.getLosgItemFromCart(losgId, CartActions_1.ItemType.VOICEPLAN.toString())
                        ? true : false)));
    };
    Utilities.featuresDeviceResponse = function () {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var deviceDetailResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_DEVICE_DETAIL_RESPONSE_KEY);
        return (Utilities.isKeyExist(deviceDetailResponse, 'features') &&
            !Utilities.isEmptyObject(deviceDetailResponse.features));
    };
    Utilities.progressiveStepsUpdate = function (_value, losgId, updateType) {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var progressiveSteps = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_PROGRESSIVE_STEPS);
        progressiveSteps && Object.keys(progressiveSteps).forEach(function (key, index) {
            if (key == losgId) {
                progressiveSteps[key][updateType] = _value;
            }
        });
        stateManager.set(WirelessConstants_1.WirelessConstants.WIRELESS_PROGRESSIVE_STEPS, progressiveSteps);
    };
    Utilities.getProgressiveSteps = function (losgId) {
        var getProgressiveSteps;
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var progressiveSteps = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_PROGRESSIVE_STEPS);
        progressiveSteps && Object.keys(progressiveSteps).forEach(function (key, index) {
            if (key == losgId) {
                getProgressiveSteps = progressiveSteps[key];
            }
        });
        return getProgressiveSteps;
    };
    Utilities.removeProgressiveStep = function (losgId, stepType) {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var progressiveSteps = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_PROGRESSIVE_STEPS);
        progressiveSteps && Object.keys(progressiveSteps).forEach(function (key, index) {
            if (key == losgId) {
                for (var _i = 0, _a = Object.keys(progressiveSteps[key]); _i < _a.length; _i++) {
                    var step = _a[_i];
                    if (step == stepType && progressiveSteps[key].hasOwnProperty(step)) {
                        delete progressiveSteps[key][step];
                    }
                }
            }
        });
        stateManager.set(WirelessConstants_1.WirelessConstants.WIRELESS_PROGRESSIVE_STEPS, progressiveSteps);
    };
    Utilities.currentDeviceCompeleteStatus = function (stepType, losgId) {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var isStepComplete = false;
        var progressiveSteps = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_PROGRESSIVE_STEPS);
        progressiveSteps && Object.keys(progressiveSteps).forEach(function (key, index) {
            // tslint:disable-next-line: triple-equals
            if (progressiveSteps[key][stepType] === true && key === losgId) {
                isStepComplete = true;
            }
        });
        return isStepComplete;
    };
    Utilities.progressiveGoToCart = function (stepType) {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var isStepComplete = true;
        var progressiveSteps = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_PROGRESSIVE_STEPS);
        progressiveSteps && Object.keys(progressiveSteps).forEach(function (key, index) {
            if (isStepComplete === true && Object.keys(progressiveSteps[key]).length === 0 || !progressiveSteps[key].hasOwnProperty(stepType)
                || progressiveSteps[key][stepType] === false) {
                isStepComplete = false;
            }
            if (isStepComplete === true && Object.keys(progressiveSteps[key]).length > 1) {
                for (var _i = 0, _a = Object.keys(progressiveSteps[key]); _i < _a.length; _i++) {
                    var step = _a[_i];
                    if (step !== stepType && progressiveSteps[key].hasOwnProperty(step) && progressiveSteps[key][step] === false) {
                        isStepComplete = false;
                    }
                }
            }
        });
        return isStepComplete && progressiveSteps && Object.keys(progressiveSteps).length !== 0;
    };
    // For a given losg check if device is has insurance or not
    Utilities.updateInsuranceForLosg = function (losgId, action) {
        if (!losgId) {
            return;
        }
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var hasFeatureInfo = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_LOSG_HAS_FEATURE);
        var deviceDetailResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_DEVICE_DETAIL_RESPONSE_KEY);
        switch (action) {
            case 'add':
                if (!Utilities.isEmptyObject(deviceDetailResponse)) {
                    var hasFeatureInfoTemp = { losgId: losgId, hasFeature: false };
                    if (Utilities.isKeyExist(deviceDetailResponse, 'features')) {
                        hasFeatureInfoTemp.hasFeature = true;
                    }
                    if (!Utilities.isEmptyObject(hasFeatureInfo) && hasFeatureInfo.length > 0 && hasFeatureInfo.find(function (item) { return item.losgId === losgId; })) {
                        var filteredItems = hasFeatureInfo.filter(function (item) { return item.losgId != losgId; });
                        filteredItems.push(hasFeatureInfoTemp);
                        stateManager.set(WirelessConstants_1.WirelessConstants.WIRELESS_LOSG_HAS_FEATURE, filteredItems);
                    }
                    else if (!Utilities.isEmptyObject(hasFeatureInfo) && hasFeatureInfo.length > 0) {
                        hasFeatureInfo.push(hasFeatureInfoTemp);
                        stateManager.set(WirelessConstants_1.WirelessConstants.WIRELESS_LOSG_HAS_FEATURE, hasFeatureInfo);
                    }
                    else {
                        var hasFeatureInfoArr = [];
                        hasFeatureInfoArr.push(hasFeatureInfoTemp);
                        stateManager.set(WirelessConstants_1.WirelessConstants.WIRELESS_LOSG_HAS_FEATURE, hasFeatureInfoArr);
                    }
                }
                break;
            case 'remove':
                if (!Utilities.isEmptyObject(hasFeatureInfo) && hasFeatureInfo.length > 0) {
                    var filteredItems = hasFeatureInfo.filter(function (item) { return item.losgId != losgId; });
                    stateManager.set(WirelessConstants_1.WirelessConstants.WIRELESS_LOSG_HAS_FEATURE, filteredItems);
                }
                break;
        }
    };
    /**
     * @function checkIfDeviceHasInsurance
     * @description Checks if device has Insurance.
     * @param losgId string
     * @returns hasFeature boolean
     */
    Utilities.checkIfDeviceHasInsurance = function (losgId) {
        var hasFeature = false;
        var hasFeatureInfo = StateProvider_1.StateProvider.getStateManagerInstance().get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_LOSG_HAS_FEATURE);
        if (!Utilities.isEmptyObject(hasFeatureInfo) && hasFeatureInfo.length > 0) {
            for (var _i = 0, hasFeatureInfo_1 = hasFeatureInfo; _i < hasFeatureInfo_1.length; _i++) {
                var feature = hasFeatureInfo_1[_i];
                if (feature.losgId === losgId) {
                    hasFeature = feature.hasFeature;
                    break;
                }
            }
        }
        return hasFeature;
    };
    Utilities.isDeviceInCartForLosg = function (losg) {
        var foundDevice = Utilities.isEmptyObject(losg) || Utilities.isEmptyObject(losg.lineItems) ? null :
            Object.values(losg.lineItems)
                .find(function (line) { return (line && line._itemType && line._itemType.toLowerCase() === CartActions_1.ItemType.DEVICE.toLowerCase()) ||
                (line && line.itemType && line.itemType.toLowerCase() === CartActions_1.ItemType.DEVICE.toLowerCase()); });
        if (foundDevice) {
            return true;
        }
        return false;
    };
    Utilities.isHylaTradeInInCartForLosg = function (losg) {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        var hylaFromSM = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_HYLA_TRADEIN);
        var hasHylaOffer = false;
        // For a given losg check if one of the following 3 conditions meet
        // 1. check if hylaTradeInAvailable is set to true ( on device selection is set to true if tradein promo available)
        // 2. check if hylaTradeInCustomerConsented is set to true (when user selects Trade-in option)
        // 3. check if hylaTradeInIntentRejected is set to true ( when user selects No Thanks for trade-in)
        if (cartResponse && Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs')) {
            var temp = Object.values(cartResponse.content.payload.wirelessCart.losgs).find(function (p_losg) {
                return p_losg.id === (losg === null || losg === void 0 ? void 0 : losg.id) && (p_losg._hylaTradeInCustomerConsented === true ||
                    (Utilities.isKeyExist(p_losg, '_extraParams.hylaTradeInIntentRejected') && p_losg._extraParams.hylaTradeInIntentRejected === 'true'));
            });
            if (temp) {
                hasHylaOffer = true;
            }
        }
        // If still unable to determine based on above 2 approach check progressive session variable
        if (!hasHylaOffer) {
            hasHylaOffer = Utilities.currentDeviceCompeleteStatus('tradeInCompleted', losg === null || losg === void 0 ? void 0 : losg.id);
        }
        return hasHylaOffer;
    };
    Utilities.isHylaPortInInCartForLosg = function (losg) {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var cartResponse = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        var hylaFromSM = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_HYLA_TRADEIN);
        var hasHylaOffer = false;
        // For a given losg check if one of the following 3 conditions meet
        // 1. check if portinPromotionAvailable is set to true ( on device selection is set to true if portin promo available)
        // 2. check if _portinCustomerConsented is set to true (when user selects Port-in option)
        // 3. check if hylaPortInIntentRejected is set to true ( when user selects No Thanks for port-in)
        if (cartResponse && Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs')) {
            var temp = Object.values(cartResponse.content.payload.wirelessCart.losgs).find(function (p_losg) {
                return p_losg.id === (losg === null || losg === void 0 ? void 0 : losg.id) && (p_losg._portinCustomerConsented === true ||
                    (Utilities.isKeyExist(p_losg, '_extraParams.hylaPortInIntentRejected') && p_losg._extraParams.hylaPortInIntentRejected === 'true'));
            });
            if (temp) {
                hasHylaOffer = true;
            }
        }
        // If still unable to determine based on above 2 approach check progressive session variable
        if (!hasHylaOffer) {
            hasHylaOffer = Utilities.currentDeviceCompeleteStatus('portInCompleted', losg === null || losg === void 0 ? void 0 : losg.id);
        }
        return hasHylaOffer;
    };
    Utilities.hasInsuranceInCartForLosg = function (losg) {
        var cartResponse = StateProvider_1.StateProvider.getStateManagerInstance().get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_CART_RESPONSE_KEY);
        var hasInsurance;
        var returnValue = false;
        // For a given losg check if any one of the following 2 conditions are meet
        // 1. Check if the lineItem contains itemType=feature (when insurance is added to cart)
        // 2. Check if _insuranceCustomerConsented falg is set to true (when customer selects or rejects insurance)
        if (cartResponse && Utilities.isKeyExist(cartResponse, 'content.payload.wirelessCart.losgs')) {
            hasInsurance = Object.values(cartResponse.content.payload.wirelessCart.losgs).find(function (p_losg) {
                p_losg.id === losg.id && !Utilities.isEmptyObject(p_losg.lineItems)
                    && Object.values(p_losg.lineItems).find(function (lines) {
                        return lines && lines.itemType.toLowerCase() === CartActions_1.ItemType.FEATURE.toLowerCase() && lines.offerId !== 'NOT_AVAILABLE';
                    });
            });
            if (!hasInsurance) {
                hasInsurance = Object.values(cartResponse.content.payload.wirelessCart.losgs).find(function (p_losg) {
                    return Utilities.isKeyExist(p_losg, '_extraParams._insuranceCustomerConsented') && p_losg._extraParams._insuranceCustomerConsented === 'true';
                });
            }
            returnValue = hasInsurance ? true : false;
        }
        // If still unable to determine based on above approach check progressive session variable
        if (!returnValue) {
            returnValue = Utilities.currentDeviceCompeleteStatus('insuranceInCompleted', losg === null || losg === void 0 ? void 0 : losg.id);
        }
        return returnValue;
    };
    Utilities.isPlanInCartForLosg = function (losg) {
        return Utilities.getLosgItemFromCart(losg === null || losg === void 0 ? void 0 : losg.id, CartActions_1.ItemType.SHARED_DATA_GROUP)
            || Utilities.getLosgItemFromCart(losg === null || losg === void 0 ? void 0 : losg.id, CartActions_1.ItemType.DATAPLAN);
    };
    Utilities.isProgressiveStepByStepFlow = function () {
        return ((Utilities.isIxpFeatureEnabled('svc-idp-wireless-enable-progressive-upgrade-flow') &&
            Utilities.isUpgradeFlow()) || (Utilities.isIxpFeatureEnabled('svc-enable-progressive-flow')
            && !Utilities.isUpgradeFlow()));
    };
    Utilities.isHylaTradeInFlag = function (losg) {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var hylaFromSM = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_HYLA_TRADEIN);
        var isHylaTradeIn = false;
        if (!Utilities.isEmptyObject(hylaFromSM) && hylaFromSM.length > 0
            && (!losg._selectedUpgradeOption || (losg._selectedUpgradeOption.
                toUpperCase().search('PAYUP|TRADEIN') === -1))) {
            for (var _i = 0, hylaFromSM_1 = hylaFromSM; _i < hylaFromSM_1.length; _i++) {
                var hyla = hylaFromSM_1[_i];
                if (hyla.losgId === losg.id && hyla.tradeIn === true) {
                    isHylaTradeIn = true;
                }
            }
        }
        return isHylaTradeIn;
    };
    Utilities.sortedPromoReference = function (deviceCard) {
        var _this = this;
        var _a, _b;
        if (deviceCard) {
            var promoPricing = (_a = deviceCard === null || deviceCard === void 0 ? void 0 : deviceCard.participatingPromotionalOfferReferences) === null || _a === void 0 ? void 0 : _a.map(function (promo) {
                var _a;
                for (var _i = 0, _b = deviceCard.prices; _i < _b.length; _i++) {
                    var price = _b[_i];
                    return (_a = price.promoPricing) === null || _a === void 0 ? void 0 : _a.filter(function (promoPrice) { return (promoPrice === null || promoPrice === void 0 ? void 0 : promoPrice.promoReference) === promo; });
                }
            });
            if ((promoPricing === null || promoPricing === void 0 ? void 0 : promoPricing.length) >= 1) {
                var nextTradeInPromo = promoPricing && promoPricing.filter(function (promoPrice) {
                    var _a, _b;
                    return promoPrice &&
                        ((_a = promoPrice[0]) === null || _a === void 0 ? void 0 : _a.promoType) === 'tradein' && ((_b = promoPrice[0]) === null || _b === void 0 ? void 0 : _b.tradeInEligibilityReason) === 'nextTradeIn';
                });
                var standalonePromo = [];
                if (nextTradeInPromo.length === 0) {
                    standalonePromo = promoPricing && promoPricing.filter(function (promoPrice) {
                        var _a;
                        return promoPrice &&
                            ((_a = promoPrice[0]) === null || _a === void 0 ? void 0 : _a.promoType) === 'standalone';
                    });
                }
                var regularTradeInPromo = [];
                if (nextTradeInPromo && nextTradeInPromo.length === 0 && standalonePromo && standalonePromo.length === 0) {
                    regularTradeInPromo = promoPricing && promoPricing.filter(function (promoPrice) {
                        var _a, _b;
                        return promoPrice &&
                            ((_a = promoPrice[0]) === null || _a === void 0 ? void 0 : _a.promoType) === 'tradein' && ((_b = promoPrice[0]) === null || _b === void 0 ? void 0 : _b.tradeInEligibilityReason) === 'regularTradeIn';
                    });
                }
                var promoPrimeObj_1 = nextTradeInPromo.length !== 0 ? nextTradeInPromo :
                    standalonePromo.length !== 0 ? standalonePromo : regularTradeInPromo;
                promoPrimeObj_1.sort(function (promo1, promo2) { var _a, _b; return parseInt(promo1[0] && ((_a = promo1[0]) === null || _a === void 0 ? void 0 : _a.marketingPriority)) - parseInt(promo2[0] && ((_b = promo2[0]) === null || _b === void 0 ? void 0 : _b.marketingPriority)); });
                return deviceCard && ((_b = deviceCard.promotions) === null || _b === void 0 ? void 0 : _b.filter(function (promo) {
                    var _a;
                    return String(promo.id) === String(!_this.isEmptyObject(promoPrimeObj_1) && !_this.isEmptyObject(promoPrimeObj_1[0]) &&
                        ((_a = promoPrimeObj_1[0][0]) === null || _a === void 0 ? void 0 : _a.promoReference));
                }));
            }
        }
    };
    Utilities.mandatoryStepsComplete = function (losg) {
        var cartResponse = Utilities.getCartResponse();
        if (!Utilities.isBYODFlow()) {
            if ((!Utilities.isHylaTradeInFlag(losg) ||
                (Utilities.isHylaTradeInFlag(losg) &&
                    Utilities.hasHylaTradeInOffer(losg === null || losg === void 0 ? void 0 : losg.id) === Utilities.currentDeviceCompeleteStatus('tradeInCompleted', losg === null || losg === void 0 ? void 0 : losg.id)))
                && ((losg === null || losg === void 0 ? void 0 : losg.losgType) === CartActions_2.LosgType.UP ? true : Utilities.hasPortInOffer(losg === null || losg === void 0 ? void 0 : losg.id) === Utilities.currentDeviceCompeleteStatus('portInCompleted', losg === null || losg === void 0 ? void 0 : losg.id))
                && Utilities.checkIfDeviceHasInsurance(losg === null || losg === void 0 ? void 0 : losg.id) === Utilities.currentDeviceCompeleteStatus('insuranceCompleted', losg === null || losg === void 0 ? void 0 : losg.id)) {
                return true;
            }
        }
        else {
            return true;
        }
        return false;
    };
    /**
     * @function getProgressiveStepStatus
     * @param step ProgressiveSteps, can be Tradein | Insurance | PortIn | Plan
     * @param losg Losg
     * @description Gets progressive step status
     * @returns ProgressiveStepStatus
     */
    Utilities.getProgressiveStepStatus = function (step, losg) {
        var returnStatus;
        switch (step) {
            case "DEVICE_IN_CART" /* DEVICE_IN_CART */:
                if (!Utilities.isEmptyObject(Utilities.getLosgItemFromCart(losg.id, CartActions_1.ItemType.DEVICE))) {
                    return "EXPANDED" /* EXPANDED */;
                }
                else {
                    return "COLLAPSED" /* COLLAPSED */;
                }
                break;
            case "TRADE-IN" /* TRADE_IN */:
                if (!Utilities.hasHylaTradeInOffer(losg.id)) {
                    return "SUPPRESSED" /* SUPPRESSED */;
                }
                if (Utilities.hasHylaTradeInOffer(losg.id)
                    && ((Utilities.isKeyExist(losg, '_hylaTradeInCustomerConsented') && losg._hylaTradeInCustomerConsented === true)
                        || (Utilities.isKeyExist(losg, '_extraParams.hylaTradeInIntentRejected') && losg._extraParams.hylaTradeInIntentRejected === 'true'))) {
                    return "COLLAPSED" /* COLLAPSED */;
                }
                if (Utilities.currentDeviceCompeleteStatus('tradeInCompleted', losg.id)) {
                    return "COLLAPSED" /* COLLAPSED */;
                }
                if (Utilities.getProgressiveStepStatus("DEVICE_IN_CART" /* DEVICE_IN_CART */, losg) === "COLLAPSED" /* COLLAPSED */
                    && Utilities.hasHylaTradeInOffer(losg.id)) {
                    return "EXPANDED" /* EXPANDED */;
                }
                if (Utilities.hasHylaTradeInOffer(losg.id)) {
                    return "CLOSED" /* CLOSED */;
                }
                break;
            case "PORT-IN" /* PORT_IN */:
                if (!Utilities.hasPortInOffer(losg.id)) {
                    return "SUPPRESSED" /* SUPPRESSED */;
                }
                if (Utilities.hasPortInOffer(losg.id)
                    && ((Utilities.isKeyExist(losg, '_portinCustomerConsented') && losg._portinCustomerConsented === true)
                        || (Utilities.isKeyExist(losg, '_extraParams.hylaPortInIntentRejected') && losg._extraParams.hylaPortInIntentRejected === 'true'))) {
                    return "COLLAPSED" /* COLLAPSED */;
                }
                if (Utilities.currentDeviceCompeleteStatus('portInCompleted', losg.id)) {
                    return "COLLAPSED" /* COLLAPSED */;
                }
                if (Utilities.getProgressiveStepStatus("DEVICE_IN_CART" /* DEVICE_IN_CART */, losg) === "COLLAPSED" /* COLLAPSED */
                    && (Utilities.hasHylaTradeInOffer(losg.id) &&
                        Utilities.getProgressiveStepStatus("TRADE-IN" /* TRADE_IN */, losg) === "COLLAPSED" /* COLLAPSED */)
                    && Utilities.hasPortInOffer(losg.id)) {
                    return "EXPANDED" /* EXPANDED */;
                }
                if (Utilities.hasPortInOffer(losg.id)) {
                    return "CLOSED" /* CLOSED */;
                }
                break;
            case "INSURANCE" /* INSURANCE */:
                if (!Utilities.checkIfDeviceHasInsurance(losg.id)) {
                    return "SUPPRESSED" /* SUPPRESSED */;
                }
                if (Utilities.checkIfDeviceHasInsurance(losg.id)
                    && (!Utilities.isEmptyObject(Utilities.getLosgItemFromCart(losg.id, CartActions_1.ItemType.FEATURE, CartActions_1.ProductSubType.INSURANCE))
                        || (Utilities.isKeyExist(losg, '_extraParams._insuranceCustomerConsented') && losg._extraParams._insuranceCustomerConsented === 'true'))) {
                    return "COLLAPSED" /* COLLAPSED */;
                }
                if (Utilities.currentDeviceCompeleteStatus('insuranceCompleted', losg.id)) {
                    return "COLLAPSED" /* COLLAPSED */;
                }
                if (Utilities.getProgressiveStepStatus("DEVICE_IN_CART" /* DEVICE_IN_CART */, losg) === "COLLAPSED" /* COLLAPSED */
                    && (Utilities.hasHylaTradeInOffer(losg.id) && Utilities.getProgressiveStepStatus("TRADE-IN" /* TRADE_IN */, losg) === "COLLAPSED" /* COLLAPSED */)
                    && (Utilities.hasPortInOffer(losg.id) && Utilities.getProgressiveStepStatus("PORT-IN" /* PORT_IN */, losg) === "COLLAPSED" /* COLLAPSED */)) {
                    return "EXPANDED" /* EXPANDED */;
                }
                if (!Utilities.checkIfDeviceHasInsurance(losg.id)) {
                    return "CLOSED" /* CLOSED */;
                }
                break;
            case "PLAN" /* PLAN */:
                var authDetails = StateProvider_1.StateProvider.getStateManagerInstance().get(WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE, WirelessConstants_1.WirelessConstants.APPSHELL_WIRELESS_AUTH_DETAILS);
                if (Utilities.isAALFlow() && Utilities.isLegacyAccount()
                    && authDetails && authDetails.eligibleForNewPlan && !authDetails.eligibleForNewPlan) {
                    return "SUPPRESSED" /* SUPPRESSED */;
                }
                if (!Utilities.isEmptyObject(Utilities.getLosgItemFromCart(losg.id, CartActions_1.ItemType.SHARED_DATA_GROUP))
                    || !Utilities.isEmptyObject(Utilities.getLosgItemFromCart(losg.id, CartActions_1.ItemType.VOICEPLAN))) {
                    return "COLLAPSED" /* COLLAPSED */;
                }
                if (Utilities.getProgressiveStepStatus("DEVICE_IN_CART" /* DEVICE_IN_CART */, losg) === "COLLAPSED" /* COLLAPSED */
                    && (Utilities.hasHylaTradeInOffer(losg.id) && Utilities.getProgressiveStepStatus("TRADE-IN" /* TRADE_IN */, losg) === "COLLAPSED" /* COLLAPSED */)
                    && (Utilities.hasPortInOffer(losg.id) && Utilities.getProgressiveStepStatus("PORT-IN" /* PORT_IN */, losg) === "COLLAPSED" /* COLLAPSED */)
                    && (Utilities.checkIfDeviceHasInsurance(losg.id) && Utilities.getProgressiveStepStatus("INSURANCE" /* INSURANCE */, losg) === "COLLAPSED" /* COLLAPSED */)) {
                    return "EXPANDED" /* EXPANDED */;
                }
                return "CLOSED" /* CLOSED */;
                break;
        }
    };
    /**
     * @function getProdEnabledIXPFlags
     * @description Gets prod IXP flags
     * @returns Array<string>
     */
    Utilities.getProdEnabledIXPFlags = function () {
        var ProdEnabledIXPFlags = [
            'svc-enable-strike-through',
            'svc-pcv1-enable-promotion-collapsedpanel',
            'svc-pcv1-lnp-collapsed-panel',
            'svc-pcv1-iru-fanprofilems',
            'svc-pcv1-entertainment-hbo-max',
            'svc-pcv1-pick-other-device-btn-modal',
            'svc-pcv1-plan-price-strikethrough',
            'svc-sticky-bar-zero-amount-enable',
        ];
        return ProdEnabledIXPFlags;
    };
    /* check if the device commitment term is NOCOMMIT or not */
    Utilities.isNoCommitLine = function (losg) {
        var lineItem = Utilities.getLosgItemFromCart(losg === null || losg === void 0 ? void 0 : losg.id, CartActions_1.ItemType.DEVICE);
        return lineItem && Utilities.isKeyExist(lineItem, 'contractDetails.contractType')
            && lineItem.contractDetails.contractType.toUpperCase() === 'NOCOMMIT';
    };
    // Check the user is eligible for new plan if the plan is full
    Utilities.isEligibleForNewPlan = function () {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        var authDetails = stateManager.get(WirelessConstants_1.WirelessConstants.APPSHELL_NAMESPACE, WirelessConstants_1.WirelessConstants.APPSHELL_WIRELESS_AUTH_DETAILS);
        return authDetails === null || authDetails === void 0 ? void 0 : authDetails.eligibleForNewPlan;
    };
    Utilities.getConnectedCarOrderSrc = function (param) {
        var qParam = param ? param : WirelessConstants_1.WirelessConstants.CONNECTED_CAR_ORDER_SRC;
        var authRedirectUrlSession = sessionStorage.getItem('Wireless:AuthRedirectUrl');
        var qParamValue = new URLSearchParams(authRedirectUrlSession).get(qParam);
        if (param && !qParamValue) {
            var authDetails = this.getAuthDetails();
            qParamValue = authDetails === null || authDetails === void 0 ? void 0 : authDetails.connectedCarId;
        }
        return qParamValue;
    };
    Utilities.getSignatureImagePath = function (fanCMSSignature) {
        var _a, _b, _c, _d, _e, _f;
        if (Array.isArray(fanCMSSignature) && fanCMSSignature.length) {
            var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
            var getFanDetails = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_FAN_DETAILS_RESPONSE);
            var getCatagoryValue = (_c = (_b = (_a = getFanDetails === null || getFanDetails === void 0 ? void 0 : getFanDetails.discountDetails) === null || _a === void 0 ? void 0 : _a.affinityTag) === null || _b === void 0 ? void 0 : _b.category) === null || _c === void 0 ? void 0 : _c.value;
            var getSubCateValue = (_f = (_e = (_d = getFanDetails === null || getFanDetails === void 0 ? void 0 : getFanDetails.discountDetails) === null || _d === void 0 ? void 0 : _d.affinityTag) === null || _e === void 0 ? void 0 : _e.subCategory1) === null || _f === void 0 ? void 0 : _f.value;
            var getFinalValue_1 = getCatagoryValue && getSubCateValue ? getCatagoryValue.toLowerCase() + ' ' + getSubCateValue.toLowerCase() : null;
            getFinalValue_1 = getFinalValue_1 ? getFinalValue_1.split(' ').join('_') : null;
            var getFanIcon = getFinalValue_1 ? fanCMSSignature.find(function (fanCms) { var _a; return ((_a = fanCms === null || fanCms === void 0 ? void 0 : fanCms.fanID) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === getFinalValue_1; }) : fanCMSSignature[0];
            return getFanIcon ? getFanIcon.icon : fanCMSSignature[0].icon;
        }
        else {
            return null;
        }
    };
    /**
     * @function isNextUpOffer
     * @description gets NextUp offer price
     * @param prices any
     * @returns boolean
     */
    Utilities.isNextUpOffer = function (prices) {
        if (Utilities.isAccountEligibleForNextUp()) {
            var isNextUpOffer = void 0;
            if ((prices === null || prices === void 0 ? void 0 : prices.length) > 0) {
                isNextUpOffer = prices.filter(function (price) {
                    if (price && price.promoPricing && (price === null || price === void 0 ? void 0 : price.promoPricing.length) > 0) {
                        for (var _i = 0, _a = price.promoPricing; _i < _a.length; _i++) {
                            var promoPrice = _a[_i];
                            if ((promoPrice === null || promoPrice === void 0 ? void 0 : promoPrice.tradeInEligibilityReason) === 'nextTradeIn') {
                                return true;
                            }
                        }
                    }
                    else {
                        return false;
                    }
                });
            }
            if ((isNextUpOffer === null || isNextUpOffer === void 0 ? void 0 : isNextUpOffer.length) > 0) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    //for offer tray
    Utilities.getOfferProviderObject = function (showOfferTray, skuId, customerType, directCall, flowType) {
        if (directCall === void 0) { directCall = false; }
        var catalogOfferObject = showOfferTray
            ? flowType && flowType !== '' ? {
                data: {
                    customerType: customerType,
                    devices: [{ skuId: skuId }],
                    flowType: flowType,
                },
            } : {
                data: {
                    customerType: customerType,
                    devices: [{ skuId: skuId }]
                },
            } : {};
        var catalogOfferObjectDirect = showOfferTray
            ? flowType && flowType !== '' ? {
                customerType: customerType,
                devices: [{ skuId: skuId }],
                flowType: flowType,
            } : {
                customerType: customerType,
                devices: [{ skuId: skuId }]
            } : {};
        return directCall
            ? {
                wireless: __assign({ source: 'offerTray' }, catalogOfferObjectDirect),
            }
            : catalogOfferObject;
    };
    Utilities.isApprovedContent = function (elements) {
        // search for dis-allowed tags
        return elements.find(function (element) {
            var allowed = Utilities.allowedTags[element.tagName];
            if (allowed) {
                if (Array.prototype.slice.call(element.attributes).find(function (attribute) { return allowed.indexOf(attribute.name) < 0; })) {
                    allowed = undefined; // found dis-allowed attribute
                }
            }
            return !allowed; // return true if dis-allowed element found
        }) === undefined;
    };
    Utilities.getHylaTradeInIntent = function () {
        var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        //const defaultToggleValue = stateManager.get(WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants.SELECTED_TOGGLE_VALUE) as {selected:boolean};
        //const userSelection = defaultToggleValue && defaultToggleValue.selected;
        //Getting value from psc toggle Intent
        var defaultToggleValue = sessionStorage.getItem(WirelessConstants_1.WirelessConstants.PLP_TOGGLE);
        var userSelection = defaultToggleValue && defaultToggleValue === 'true';
        var deviceFilter = stateManager.get(WirelessConstants_1.WirelessConstants.WIRELESS_NAMESPACE, WirelessConstants_1.WirelessConstants.WIRELESS_SELECTED_DEVICE_TYPE_FILTER_NAME);
        var filterFlag = deviceFilter && deviceFilter.name == 'Phones' ? true : false;
        var ixpFlag = Utilities.isIxpFeatureEnabled('svc-pcv1-enable-tradein-toggle-display');
        // customerFlowFlag : Flag to exclude new customer and payUp scenerio
        var customerFlowFlag = false;
        if (Utilities.isAALFlow()) {
            customerFlowFlag = true;
        }
        if (Utilities.isUpgradeFlow()) {
            var payOption = Utilities.getCustomerSelectedOption();
            customerFlowFlag = payOption && payOption == "PAYOFF" /* PAYOFF */ || payOption == "REGULAR" /* REGULAR */;
        }
        var currentToggleValue = userSelection && filterFlag && customerFlowFlag && ixpFlag;
        return currentToggleValue;
    };
    /**
     * @function checks if the product pricing
     * promotion contains isSwitcherPromo flag
     * @param productPricing
     * @returns boolean
     */
    Utilities.filterIsPromoSwitcher = function (productPricing) {
        var _a;
        var portinPromotion = (_a = productPricing === null || productPricing === void 0 ? void 0 : productPricing.promoPricing) === null || _a === void 0 ? void 0 : _a.find(function (promo) { var _a; return ((_a = promo === null || promo === void 0 ? void 0 : promo.promoType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === "STANDALONEPORTIN"; });
        if (!Utilities.isEmptyObject(portinPromotion)) {
            return true;
        }
        return false;
    };
    /**
     * @function isPrePreOrderDevice
     * @description Checks if device satisfies
     * PrePreOrder conditions
     * @param deviceSalesStatus
     * @returns bool
     */
    Utilities.isPrePreOrderDevice = function (deviceSalesStatus) {
        if (Utilities.isPpoEnabled() &&
            !Utilities.isEmpty(deviceSalesStatus) &&
            deviceSalesStatus.toUpperCase() === WirelessConstants_1.SalesStatus.PREPREORDER &&
            Utilities.isIxpFeatureEnabled('svc-pcv1-pre-preorder') && !Utilities.getCookie('DTAB')) {
            return true;
        }
        return false;
    };
    /**
     *
     * @param srcStr
     * @description masks html tags into plain text by escaping special html characters
     * @returns masked string
     */
    Utilities.escapeHtmlTags = function (srcStr) {
        if (typeof srcStr === undefined || typeof srcStr === null)
            return;
        if (typeof srcStr === 'string') {
            return srcStr.replace(/</g, "&lt;").replace(/>/g, "&gt;");
        }
        else
            return srcStr;
    };
    /**
     * @description returns html string from the escapedHtml. This is the reverse of **escapeHtmlTags** @see `Utilities.escapeHtmlTags`
     * @param srcStr
     * @returns unmasked html string
     */
    Utilities.unescapeHtmlTags = function (srcStr) {
        var _a;
        if (typeof srcStr === undefined || typeof srcStr === null)
            return;
        if (typeof srcStr === 'string') {
            var domParser = new DOMParser();
            var html = domParser.parseFromString(srcStr, "text/html");
            return (_a = html.body) === null || _a === void 0 ? void 0 : _a.innerText;
        }
        else
            return srcStr;
    };
    Utilities.getDeviceType = function (losg) {
        var _a, _b, _c;
        var lineItems = !this.isEmptyObject(losg) && Object.values(losg === null || losg === void 0 ? void 0 : losg.lineItems);
        var deviceLine = (lineItems === null || lineItems === void 0 ? void 0 : lineItems.length) > 0 && lineItems.filter(function (item) { return (item === null || item === void 0 ? void 0 : item.itemType) === 'device'; });
        var deviceType = (deviceLine === null || deviceLine === void 0 ? void 0 : deviceLine.length) > 0 && ((_c = (_b = (_a = deviceLine === null || deviceLine === void 0 ? void 0 : deviceLine[0]) === null || _a === void 0 ? void 0 : _a.hardGood) === null || _b === void 0 ? void 0 : _b.wirelessHardGoodCharacteristics) === null || _c === void 0 ? void 0 : _c.phoneType);
        return deviceType !== null && deviceType !== void 0 ? deviceType : '';
    };
    Utilities.wlsPostpaidFun = function (action, wlsPostpaidObj) {
        try {
            if (action === 'SET') {
                window.sessionStorage.setItem("wlsPostpaid", JSON.stringify(wlsPostpaidObj));
                return wlsPostpaidObj;
            }
            else if (action === 'GET') {
                var wlsPostpaidStr = window.sessionStorage.getItem("wlsPostpaid");
                return JSON.parse(wlsPostpaidStr);
            }
        }
        catch (_a) {
            return;
        }
    };
    Utilities.getUserFlowType = function () {
        var _a, _b;
        var wlsPostpaid = this.wlsPostpaidFun('GET');
        var customerIntent = (_b = (_a = wlsPostpaid === null || wlsPostpaid === void 0 ? void 0 : wlsPostpaid.wsceData) === null || _a === void 0 ? void 0 : _a.wlsfi) === null || _b === void 0 ? void 0 : _b.toUpperCase();
        if (customerIntent === Analytics_1.PostpaidIntent.UP.toUpperCase()) {
            return 'UP';
        }
        else if (customerIntent === Analytics_1.PostpaidIntent.RYD.toUpperCase()) {
            return 'RYD';
        }
        else if (customerIntent === Analytics_1.PostpaidIntent.AL.toUpperCase()) {
            return 'AL';
        }
    };
    Utilities.getReportingLiabilityType = function (liabilityTypeFromProfile) {
        if (!liabilityTypeFromProfile) {
            return 'UNKNOWN';
        }
        switch (liabilityTypeFromProfile.toUpperCase()) {
            case 'UNKNOWN':
                return 'UNKNOWN';
            case 'CRU':
                return 'CRU';
            case 'IRU':
                return 'IRU';
            case 'SMB':
                return 'CRU';
            case 'CON':
            default:
                return 'CONS';
        }
    };
    Utilities.getReportingCustomerType = function (custTypeFromProfileCall) {
        switch (custTypeFromProfileCall ? custTypeFromProfileCall.toUpperCase() : 'default') {
            case 'SMB':
            case 'CRU':
                return 'SMB';
            case 'EMP':
                return 'EMP';
            case 'RET':
                return 'RET';
            case 'IRU':
            default:
                return 'CONS';
        }
    };
    Utilities.getReportingProductType = function (flowCode, isBYOD, isaccessory, formattedCartLineItems) {
        var _a, _b;
        var wlsPostpaidObj = this.wlsPostpaidFun('GET');
        var eapProductType = ((_b = (_a = wlsPostpaidObj === null || wlsPostpaidObj === void 0 ? void 0 : wlsPostpaidObj.wsceData) === null || _a === void 0 ? void 0 : _a.eapFlow) === null || _b === void 0 ? void 0 : _b.deviceMake) === 'APPLE' ? 'EAP Postpaid Wearable Apple' : 'EAP Postpaid Wearable Android';
        var getProductType = function (flowCode, isBYOD) {
            if (isBYOD) {
                switch (flowCode) {
                    case 'DSNEW':
                        return 'Postpaid BYOD';
                    case 'EAAL':
                        return eapProductType;
                    case 'DSAAL':
                        return 'Postpaid BYOD';
                    case 'DSPREPAID':
                        return 'Prepaid BYOD';
                    case 'EAOWT':
                        return 'EAP Postpaid Off Device';
                    default:
                        return 'Postpaid BYOD';
                }
            }
            else {
                switch (flowCode) {
                    case 'DSNEW':
                        return 'Postpaid';
                    case 'DSAAL':
                        return 'Postpaid';
                    case 'EAAL':
                        return eapProductType;
                    case 'DSUP':
                        return 'Postpaid';
                    case 'DSPREPAID':
                        return 'Prepaid';
                    case 'DSACC':
                        return 'Accessory';
                    case 'EAOWT':
                        return 'EAP Postpaid Off Device';
                    default:
                        return 'Postpaid';
                }
            }
        };
        if (flowCode === 'DSAAL' && formattedCartLineItems) {
            var allDevicesInCart = formattedCartLineItems;
            if (allDevicesInCart.length > 0) {
                var isDeviceInCart = allDevicesInCart.find(function (r) { var _a; return ((_a = r === null || r === void 0 ? void 0 : r.hardGood) === null || _a === void 0 ? void 0 : _a.hardGoodType) === 'DEVICE'; });
                var isSimInCart = allDevicesInCart.find(function (r) { var _a; return ((_a = r === null || r === void 0 ? void 0 : r.hardGood) === null || _a === void 0 ? void 0 : _a.hardGoodType) === 'SIM'; });
                if (isDeviceInCart && isSimInCart) {
                    return 'Postpaid|Postpaid BYOD';
                }
                else if (isDeviceInCart) {
                    return getProductType(flowCode, false);
                }
                else if (isSimInCart) {
                    return getProductType(flowCode, true);
                }
                else {
                    return getProductType(flowCode, isBYOD);
                }
            }
            else {
                return getProductType(flowCode, isBYOD);
            }
        }
        else {
            return getProductType(flowCode, isBYOD);
        }
    };
    Utilities.getUserTypeInfo = function () {
        var _a;
        var wlsPostpaidObj = this.wlsPostpaidFun('GET');
        var customerType = (_a = wlsPostpaidObj === null || wlsPostpaidObj === void 0 ? void 0 : wlsPostpaidObj.wsceData) === null || _a === void 0 ? void 0 : _a.customerType;
        if (customerType && customerType.toUpperCase() === 'CRU') {
            return 'SMB';
        }
        else {
            return 'CONS';
        }
    };
    Utilities.eventEmitter = new events_1.EventEmitter();
    Utilities.allowedTags = {
        A: ['href', 'id', 'class', 'target'],
        BR: [],
        DIV: ['class', 'id'],
        I: [],
        NOBR: [],
        P: [],
        STRONG: [],
        SUB: ['class', 'style'],
        SUP: ['class', 'style'],
        U: [],
    };
    Utilities.calculateViewedUIExperience = function () {
        var device = window && window.innerWidth < 768 ? 'Smartphone' : window && window.innerWidth < 1025 ?
            'Tablet' : 'Desktop';
        return device;
    };
    Utilities.calculateFriendlyPageName = function (url) {
        var pageUrl = '';
        switch (url) {
            case '/buy/wireless/devices':
                pageUrl = 'DS Wireless Device List Pg';
                break;
            case '/buy/wireless/deviceconfig':
                pageUrl = 'DS Wireless Device Config Pg';
                break;
            case '/buy/wireless/prepaid/devices':
                pageUrl = 'DS Wireless Prepaid Device List Pg';
                break;
            case '/buy/wireless/prepaid/deviceconfig':
                pageUrl = 'DS Wireless Prepaid Device Config Pg';
                break;
            case '/buy/wireless/prepaid/plans':
                pageUrl = 'DS Wireless Prepaid Plans Pg';
                break;
            case '/buy/wireless/filteroptions/modal':
                pageUrl = '/buy/wireless/filteroptions/modal';
                break;
            case '/buy/wireless/devicelegal/modal':
                pageUrl = 'DS Wireless Device Legal Modal Pg';
                break;
            case '/buy/wireless/prepaid/devicelegal/modal':
                pageUrl = 'DS Wireless Prepaid Device Legal Modal Pg';
                break;
            default:
                pageUrl = 'DS Wireless Device Config Pg';
        }
        return pageUrl;
    };
    Utilities.generatePageLoadEventData = function (url, pageName, customerType, firstNetFlag, productType, flowCode, payload, additionalpayload) {
        var _a, _b, _c, _d;
        customerType = Utilities.getCustomerType();
        var finalPageName = ((_b = (_a = additionalpayload === null || additionalpayload === void 0 ? void 0 : additionalpayload.page) === null || _a === void 0 ? void 0 : _a.pageInfo) === null || _b === void 0 ? void 0 : _b.friendlyPageName) ? (_d = (_c = additionalpayload === null || additionalpayload === void 0 ? void 0 : additionalpayload.page) === null || _c === void 0 ? void 0 : _c.pageInfo) === null || _d === void 0 ? void 0 : _d.friendlyPageName : Utilities.calculateFriendlyPageName(url);
        var additionalData = __assign({ 'page.location.url': url, 'page.pageInfo.flowCode': flowCode, 'page.pageInfo.friendlyPageName': finalPageName, 'page.pageInfo.language': 'EN', 'page.pageInfo.lineOfBusiness': 'Wireless', 'user.customerType': Utilities.getReportingCustomerType(customerType), 'user.login.userType': Utilities.getUserTypeInfo(), 'datatransform': false, 'user.firstNetFlag': localStorage.getItem('fnIntend') ? 1 : 0, 'page.category.applicationName': 'Digital Sales', 'page.category.pageFunction': 'Sales', 'page.category.pageOwnership': 'Consumer', 'page.pageInfo.responsiveWebDesignFlag': 1, 'page.pageInfo.viewedUIExperience': Utilities.calculateViewedUIExperience(), 'chat.offerCode': 'Default', 'page.location._addressBarFullURL': window.location.href.toString(), 'page.location.domain': window.location.hostname, 'page.pageInfo.chatState': 'offline', 'page.pageInfo.maxPageDepthViewed': '933', 'page.attributes.productType': productType, 'user.account.liabilityType': Utilities.getReportingLiabilityType(customerType), 'page.category.siteSection': 'myATT Sales', 'page.category.pageGroup': 'SALES' }, payload);
        return additionalData;
    };
    Utilities.getReportingStatusCodeAndSuccessFlag = function (addToCartENUM) {
        switch (addToCartENUM) {
            case 1:
                // tried to add to cart, and was successful
                return {
                    statusMessage: 'Success',
                    statusCode: '0',
                    successFlag: '1',
                };
            case -1:
                // tried to add to cart, but was unsuccessful
                return {
                    statusMessage: "We've encountered an error adding your item to the cart, please try again",
                    statusCode: '-1',
                    successFlag: '0',
                };
            case 0:
            // did not add to cart, generic reporting params (devices)
            default:
                return {
                    statusMessage: 'Success',
                    statusCode: '-2',
                    successFlag: '-2',
                };
        }
    };
    return Utilities;
}());
exports.default = Utilities;
//# sourceMappingURL=Utilities.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/wireless-ui/api/Utilities.js
// module id = 811
// module chunks = 8